import React from "react";
import * as Icon from 'ubs-icons';

export const PERV_LOCATION_DISTANCE = 50 // in meters
export const IS_DEV = process.env.NODE_ENV === 'development'
export const FCM_CONFIG = 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
export const ON_BOARDING = false // true, false
export const PRODUCT_ACCESS = {HRMS: true, PMS: true, CHAT: true, PAYROLL: true}
export const imageLink = '/images/reaction/';

/**
 * Profile section keys — must match the keys used in the customFields Redux slice.
 * Mirror of the HRMS-side PROFILE_SECTION; kept here so framework code (e.g. useCustomFieldConfig)
 * can stay self-contained and not depend on a product module.
 */
export const PROFILE_SECTION = {
    basicInfo: 'basicInfo',
    familyInfo: 'familyInfo',
    nomineeInfo: 'nomineeInfo',
    dependentInfo: 'dependentInfo',
    contactInfo: 'contactInfo',
    emergencyContact: 'emergencyContact',
    social: 'social',
    address: 'address',
    contactSocial: 'contactSocial',
    bankInfo: 'bankInfo',
    location: 'location',
    subCompany: 'subCompany',
    currentAddress: 'currentAddress',
    permanentAddress: 'permanentAddress',
    education: 'education',
    previousEmployee: 'previousEmployee',
    workExperience: 'workExperience',
    jobInfo: 'jobInfo',
    agreementInfo: 'agreementInfo',
    compensationInfo: 'compensationInfo',
    employeeResignation: 'employeeResignation',
    internProbInfo: 'intenProbInfo',
    orgStructureInfo: 'orgStructureInfo',
    personalIdentifications: 'personalIdentifications',
    otherDocument: 'otherDocument',
    requisitionInfo: 'requisitionInfo',
    meeting: 'meeting',
    client: 'client',
}

export const APP = {
    THUMBOR_URL: process.env.REACT_APP_THUMBOR_URL,
    COOKIE_DAYS: 90,
    IST_OFFESET : -330,
    DEFAULT_TZ : 'Asia/Kolkata',
    UTC_TZ: 'GMT'
};

export const REGEX = {
    AT: /(\<@(.*?)\|(.*?)\>)/gim,
    OBJECT_ID: /^[a-f0-9]{24}$/,
    EMOJI: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
    ACTIVITY: /(\<\$(.*?)\|(.*?)\>)/gim,
    EMOJI_SKIN: /(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)/gim,
    ALPHANUMERIC: /^[a-zA-Z0-9 -]{1,25}$/i,
    NAME: /^([a-zA-Z ' -]{1,100})$/i,
    EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i,
    PHONE: /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i,
    ADDRESS_DEPARTMENT: /^[a-zA-Z0-9 ' , . & -]{1,100}$/i,
    CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]{1,100})*$/i,
    COMPANY: /^([-a-zA-Z0-9 ' , . & !]{1,100})$/i,
    POSTCODE: /^\d{6}(?:[-\s]\d{4})?$/i,
    IFSCCODE: /^[a-zA-Z0-9 -]{3,18}$/i,  /*/^[A-Z]{4}0[A-Z0-9]{6}$/i*/
    NUMBER: /^\d{3,50}$/i,
    BANK: /^([a-zA-Z]{1,50})$/i,
    number: /\d/, // /^(?=.*?[0-9])/,
    upperCase: /[A-Z]/, // /^(?=.*?[A-Z])/,
    lowerCase: /[a-z]/, // /^(?=.*?[a-z])/,
    specialChar: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
};
export const FILE = {
    IMAGES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i,
    VIDEO: /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i,
    AUDIO: /\.(mp3|wav|ogg|wma|m4a|flac|mp2|aac|aiff|m4r|amr|ac3|opus|gsm|wve|w64|caf|fssd|vox|dts|amb|txw|au|spx|wv|voc|tta|ra|oga|pvf|prc|maud|8svx|snd|sndr|sndt|avr|cdda|cvs|cvsd|cvu|dvms|vms|fap|paf|sou|gsrt|hcom|htk|ima|ircam|sln|sph|nist|smp|sd2)$/i,
    EXCLUDES: ['exe', 'EXE', 'dmg', 'msi'],
    DOCS: /\.(doc|docx|DOC|DOCX|pdf|PDF|js)$/i,
    MIXFILES: /\.(png|apng|jpeg|jpg|pdf|PDF)$/i,
    MIXDOC: /\.(png|apng|jpeg|jpg|pdf|PDF|doc|docx|DOC|DOCX|xlsx|xls|rtf)$/i,
    ELSXFILES: /\.(xlsx|XLSX|xls|XLS)$/i,
    DOCSFILES: /\.(doc|docx|DOC|DOCX)$/i,
    PDFFILES: /\.(pdf|PDF)$/i,
    PPTFILES: /\.(ppt|pptx|PPT|PPTX)$/i,
    TEXTFILES: /\.(txt|log|md|csv|json|xml|yml|yaml|ini|cfg|conf|env|sh|bat|cmd|csi)$/i,
    HTMLFILES: /\.(html|htm)$/i,
    CODEFILES: /\.(js|jsx|ts|tsx|mjs|cjs|py|pyw|rb|go|java|c|cpp|cc|cxx|h|hpp|cs|php|rs|swift|kt|kts|sql|css|scss|less|sass|bash|zsh|ps1|lua|r|pl|pm|dart|vue|svelte|m|mm|scala|clj|cljs|hs|elm|jl|toml|graphql|gql|tf|tfvars|proto)$/i,
    ZIPFILE: /\.(zip)$/i,
    DOCS_AND_XLS : /\.(doc|docx|DOC|DOCX|jsxlsx|XLSX)$/i,
    PDF : /\.(pdf|PDF|js)$/i,
    DOCS_ONLY : /\.(doc|docx|DOC|DOCX)$/i,
    TYPE : {
        IMAGES : 1,
        VIDEO : 2,
        AUDIO : 3,
        DOCS_ONLY : 4,
        PDF : 5,
        XLS : 6,
        DOCS : 7,
        EXCLUDES : 10
    }
};

export const ROUTES = {
    PMS: ['dashboard', 'projects', 'budgets' ,'my-tasks', 'milestones', 'timesheet', 'employees', 'resource', 'resources-planner', 'my-team-tasks', 'reports', 'work-diary', 'clients', 'settings', 'framework', 'release-note', 'notifications', 'troubleshooting', 'dependency', 'calendar', 'integration', 'work-flow', 'check-ins'],
    TASK: ['dashboard', 'list', 'kanban', 'activities', 'discussion', 'calendar', 'milestones', 'files', 'form', 'task-automation', 'mind-map' ,'task-timesheet', 'resource', 'statistics', 'tags', 'report', 'all-activity-box-list', 'import-tasks', 'activity-list', 'project-priority-list', 'files', 'task-type-list', 'task-status-list', 'billing-reports', 'integrations', 'integration', 'gantt-chart', 'task-custom-field', 'task-fields-list', 'project-custom-field', 'mom', 'finance', 'work-flow'],
};

export const FORMAT = {
    TIME: 'hh:mm A',
    TIME_FORMAT_24: 'HH:mm',
    MONTH: 'MM/YYYY',
    DATE: 'DD/MM/YYYY',
    DUE_DATE: 'DD MMM, YY',
    TICKET_DATE: 'DD MMM, YYYY',
    DAY_TIME: 'dddd hh:mm A',
    DATE_TIME: 'DD/MM/YYYY hh:mm A',
    DATE_TIME_24: 'DD/MM/YYYY HH:mm',
    FULL_DATE: 'dddd, MMMM D, YYYY',
    YEAR_MONTH: 'MMMM, YYYY',
    MONTH_DATE: 'MMM DD, YYYY',
    MONTH_DATE_TIME: 'MMM DD, YYYY, hh:mm A',
    MONTH_DATE_TIME_24: 'MMM DD, YYYY, HH:mm',
    DAY_DATE: 'ddd, MMM DD, YYYY',
    DOC_DATE_FORMAT: 'do, MMM yyyy',
    DAY_DATE_MONTH: 'ddd DD MMM, YYYY',
    FULL_DATE_TIME: 'ddd DD MMM, YYYY hh:mm A',
    FULL_DATE_TIME_24: 'ddd DD MMM, YYYY HH:mm',
    FULL_DATE_KIT_TIME: 'DD MMM YYYY (dddd)',
    ATS_DATE:'DD MMM YYYY, dddd hh:mm A',
    WORK_LOG_DATE: 'MMM D, YYYY hh:mm A',
    MONTH_YEAR_SHORT: 'MMM YYYY',
    DAY_MONTH_SHORT: 'DD MMM',
};
export const COLOR = {
    u_title: '#1e2538',
    u_font: '#73788b',
    u_blue: '#007AFF',
    u_lightfont: '#c7c7c7',
    u_gray: '#e4e4e4',
    u_dark_gray: '#7b849e',
    u_datepicker_bg: '#fafbff',
    u_thead_bg: '#fafafb',
    u_icon_bg: '#4E525F',
    u_lightgreen: '#F8FDF8',
    u_darkfont: '#5D6372',
    u_semilight_gray: '#F8F9FE',
    u_white: '#FFFFFF',
    u_green: '#60B158',
    u_orange: '#FFA700',
    u_red: '#FF6961',
    u_pastelred: '#FF6961',
    u_black: '#000000',
    u_purple: '#9A5BFF',
    u_light_slate_blue: '#9A5BFF',
    u_lightblue: '#33D6FA',
    $u_bg: '#F5F6FA',
    u_cwd: '#12CDB7',
    u_weekend: '#2F7CF6',
};

const POLICY_MARITAL_STATUS = {
    MARRIED: 1,
    UNMARRIED: 2,
    DIVORCED: 3,
    WIDOWED: 4,
    OTHER: 5,
};

export const POLICY_AUTOMATION = {
    CONDITION_FIELD: {
        COMPANY: 1,
        LOCATION: 2,
        SUB_LOCATION: 3,
        DEPARTMENT: 4,
        SUB_DEPARTMENT: 5,
        JOB_TITLE: 6,
        BUSINESS_UNIT: 7,
        COST_CENTER: 8,
        GRADE: 9,
        BANDS: 10,
        SEGMENT: 11,
        HUB: 12,
        TERRITORY: 13,
        REGION: 14,
        WORK_AREA: 15,
        EMPLOYEE_STATUS: 16,
        CATEGORY: 17,
        STATE: 18,
        COUNTRY: 19,
        LINE_MANAGER: 20,
        REPORTING_MANAGER: 21,
        MARITAL_STATUS: 22,
    },
    MARITAL_STATUS: POLICY_MARITAL_STATUS,
    MARITAL_STATUS_OPTIONS: [
        { value: POLICY_MARITAL_STATUS.MARRIED, label: 'Married' },
        { value: POLICY_MARITAL_STATUS.UNMARRIED, label: 'Unmarried' },
        { value: POLICY_MARITAL_STATUS.DIVORCED, label: 'Divorced' },
        { value: POLICY_MARITAL_STATUS.WIDOWED, label: 'Widowed' },
        { value: POLICY_MARITAL_STATUS.OTHER, label: 'Other' },
    ],
    OPERATOR: {
        IS: 1,
        IS_NOT: 2,
        CONTAINS: 3,
        IS_EMPTY: 4,
        IS_NOT_EMPTY: 5,
    },
    RULE_TYPE: {
        INCLUDE: 1,
        EXCLUDE: 2,
    },
    CONDITION_MATCH: {
        ALL: 1,
        ANY: 2,
    },
    STATUS: {
        ACTIVE: 1,
        INACTIVE: 2,
    },
    CATEGORIES: [
        { value: 'subCompany', label: 'Company', type: 'company', fieldIndex: 1, section: PROFILE_SECTION.basicInfo, key: 'companyId' },
        { value: 'branch', label: 'Location', type: 'location', fieldIndex: 2, section: PROFILE_SECTION.jobInfo },
        { value: 'subLocation', label: 'Sub Location', type: 'location', fieldIndex: 3, section: PROFILE_SECTION.jobInfo, key: 'subLocation' },
        { value: 'department', label: 'Department', type: 'department', fieldIndex: 4, section: PROFILE_SECTION.jobInfo },
        { value: 'subDepartment', label: 'Sub Department', type: 'department', fieldIndex: 5, section: PROFILE_SECTION.jobInfo, key: 'subDepartment' },
        { value: 'jobTitle', label: 'Job Title', type: 'jobTitle', fieldIndex: 6, section: PROFILE_SECTION.jobInfo },
        { value: 'businessUnit', label: 'Business Unit', type: 'businessUnit', fieldIndex: 7, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'costCenter', label: 'Cost Center', type: 'costCenter', fieldIndex: 8, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'grade', label: 'Grade', type: 'grade', fieldIndex: 9, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'bands', label: 'Bands', type: 'bands', fieldIndex: 10, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'segment', label: 'Segment', type: 'segment', fieldIndex: 11, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'hub', label: 'Hub', type: 'hub', fieldIndex: 12, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'territory', label: 'Territory', type: 'territory', fieldIndex: 13, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'region', label: 'Region', type: 'region', fieldIndex: 14, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'workArea', label: 'Work Area', type: 'workArea', fieldIndex: 15, section: PROFILE_SECTION.orgStructureInfo },
        { value: 'employeeStatus', label: 'Employment Status', type: 'employeeStatus', fieldIndex: 16, section: PROFILE_SECTION.jobInfo },
        { value: 'category', label: 'Category', type: 'category', fieldIndex: 17, section: PROFILE_SECTION.jobInfo },
        { value: 'state', label: 'State', type: 'state', fieldIndex: 18, section: PROFILE_SECTION.location, key: 'state' },
        { value: 'lineManager', label: 'Line Manager', type: 'lineManager', fieldIndex: 20, section: PROFILE_SECTION.jobInfo, key: 'lineManager' },
        { value: 'reportingManager', label: 'Reporting Manager', type: 'reportingManager', fieldIndex: 21, section: PROFILE_SECTION.jobInfo, key: 'reportTo' },
        { value: 'maritalStatus', label: 'Marital Status', type: 'maritalStatus', fieldIndex: 22, section: PROFILE_SECTION.basicInfo, key: 'maritalStatus', isNumeric: true, policyTypes: [1] },
    ]
}

export const LIMIT = {
    SEARCH_CHARACTER: 2,
    TOAST_TIME_OUT: 5000,
    DE_BOUNCING_TIME_OUT: 1000,
    DE_BOUNCING_TIME_OUT_TICKET: 1000,
    TOOLTIP_DELAY: 500,
    PAGINATION: 25,
    SUB_TASK_LEVEL: 4,
    ACTIVITY_PAGINATION: 10,
    BULK_SELECTION_LIMIT: 20,
};

export const FORMULA_TYPE = { PERCENTAGE: 1, FIXED: 2, FORMULA: 3 };
export const CALCULATION_TYPE = [
    { label: 'Percentage', value: FORMULA_TYPE.PERCENTAGE },
    { label: 'Fixed Amount', value: FORMULA_TYPE.FIXED },
    { label: 'Formula', value: FORMULA_TYPE.FORMULA },
];
export const SALARY_TEMPLATE = [
    { label: 'HRMS', value: 1 },
    { label: 'PAYROLL', value: 2 },
    { label: 'RECRUIT', value: 3 },
];

export const PAGINATION = {
    CURRENT_PAGE: 1,
    LIMIT: 40,
    LIMIT100: 100,
}
export const RECORDPERPAGE = [
    {value: 20, label: '20'},
    {value: 40, label: '40'},
    {value: 60, label: '60'},
    {value: 80, label: '80'},
    {value: 100, label: '100'},
];
export const HRMS_STATUS = {
    HOLIDAY: {
        FULL_DAY: 1,
        FIRST_HALF: 2,
        SECOND_HALF: 3,
    },
    WEEK_DAY: {
        SUNDAY: 0,
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
    },
    WEEK_NUMBER: [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
    ],
    TAG_CODES: ["st", "nd", "rd", "th", "th", "th"],
    WEEKEND_TYPE: {
        WORK: 0,
        FIRSTHALF: 1,
        SECONDHALF: 2,
        FULLDAY: 3,
    },
    DAY_NUMBER: {
        FIRST: 1,
        SECOND: 2,
        THIRD: 3,
        FOURTH: 4,
        FIFTH: 5,
    },
    TIME_SHEET_TYPE: {
        WORK: 1,
        BREAK: 2,
    },
    TIME_SHEET_REQUEST_STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
        CANCELLED: 4,
    },
    TIME_SHEET_REQUEST_TYPE: {
        ADD: 1,
        UPDATE: 2,
        CLOCK_IN_APPROVAL: 3,
    },
    DAILY_REPORT_TIME_STATUS: {
        INITIAL: 1,
        WORK: 2,
        BREAK: 3,
        END: 4,
    },
    DAILY_REPORT_STATUS: {
        PENDING: 1,
        COMPLETE: 2,
        REQUESTED: 3,
        LEAVE_REQUESTED: 4,

        /** Attendance Popup Constants */
        LEAVE_EARLY_OUT: 5,
        EARLY_OUT: 6,
    },
    DAILY_REPORT_DAY_STATUS: {
        HOLIDAY: 1,
        WEEKEND: 2,
        WORKING: 3,
        FIRST_HALF_WORKING: 4,
        SECOND_HALF_WORKING: 5,
        FULL_DAY_LEAVE: 6,
        FIRST_HALF_LEAVE: 7,
        SECOND_HALF_LEAVE: 8,
        PRESENT_BY_DEFAULT: 9,
        NON_WORKING: 10,
        FIRST_HALF_NON_WORKING: 11,
        SECOND_HALF_NON_WORKING: 12,
        FIRST_HALF: 13,
        SECOND_HALF: 14,
        WORKING_DAY: 15,
    },
    LEAVE_TYPE: {
        FULL_DAY: 1,
        FIRST_HALF: 2,
        SECOND_HALF: 3,
        HOURLY: 4,
        SHORT: 5,
    },
    ROUND_OFF_TO: [
        {label: 'Nearest', value: 1},
        {label: 'Minimum', value: 2},
        {label: 'Maximum', value: 3},
    ],
    ROUND_OFF_DAY: [
        {label: 'Day', value: 1},
        {label: 'Half Day', value: 2},
        {label: 'Quarter Day', value: 3},
    ],
    ROUND_OFF_HOUR: [
        {label: 'Hour', value: 1},
        {label: '30 Min', value: 2},
        {label: '15 Min', value: 3},
    ],
    DROPDOWN_LIST_TYPE: {
        PROJECT: 1,
        TASK: 2,
        ACTIVITY: 3,
        USER: 4,
    },
    FINAL_OUT_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    TIME_SHEET_ADDED_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    PROJECT_WORK_LOG_ADDED_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    SEARCH_IN_TYPE: {
        PROJECT: 1,
        PROJECT_TASK: 2,
        PROJECT_ACTIVITY_TYPE: 3,
    },
    SHIFT_TOTAL_HOUR_CALCULATION_TYPE: {
        FIRST_LAST_CHECK_OUT: 1,
        EVERY_CHECK_OUT: 2,
    },
    OVER_TIME_PAY_TYPE: {
        HOURS: 1,
        FIXED: 2,
    },
    OVER_TIME_LEVEL1: {
        USER: 1,
        UAC: 2,
    },
    FF_REQUEST_STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
        CANCELLED: 4,
    },
};
export const LOGIN_METHOD = {
    WEB: 1,
    MOBILE: 2,
    DESKTOP: 3,
    FACE_CLOCK_IN: 4,
    BIOMETRIC: 5,
    GEO_TAGGING: 6,
    CLOCK_IN_WITH_SELFIE: 7,
}

/** Reason shown on the timer when a clock-in/out is held for approval. */

export const CLOCK_IN_REASON_BY_METHOD = {
    1: 'from Web',
    2: 'from Mobile',
    3: 'from Desktop',
    4: 'due to geo-fencing restriction',
    5: 'due to geo-fencing restriction',
    6: 'due to your On-Duty/WHF request',
    7: 'due to your On-Duty/WHF request',
    8: 'due to IP restriction'
};
export const CLOCK_OUT_REASON_BY_METHOD = {
    1: 'from Web',
    2: 'from Mobile',
    3: 'from Desktop',
    4: 'due to geo-fencing restriction',
    5: 'due to geo-fencing restriction',
    6: 'due to your On-Duty/WHF request',
    7: 'due to your On-Duty/WHF request',
    8: 'due to IP restriction'
};

// Super track
export const ELECTRON_APP_TYPE = {
    SUPER_TRACK: 1,
    SUPER_CHAT: 2,
    AUTO: 3,

    LIST: [
        { value: 1, label: 'Super Track' },
        { value: 2, label: 'Super Chat' },
        { value: 3, label: 'Auto' },
    ],
}
export const CONSTANT = {
    NULL_ASSIGN: {label: 'Unassigned', value: '-'},
    NULL_PRIORITY: {label: 'No Priority', value: null},
    NULL_SECTION: {label: 'No Section', value: null},
    NULL_MILESTONE: {label: 'No Milestone', value: null},
    NULL_TASK_TYPE: {label: 'No TaskType', value: null},
    NULL_TASK_STATUS: {label: 'No TaskStatus', value: null},
    NULL_TAGS: {label: 'No Tags', value: []},
    COLORS: [
        "#1d873f",
        "#0f7fff",
        "#ffa801",
        "#fe6f5e",
        "#8e3b99",
        "#618b8c",
        "#ff55a3",
        "#009e60",
        "#DF73FF",
        "#ffb871",
        "#6495ed",
        "#45b1e8",
        "#77dd77",
        "#9c8e8e",
        "#7F5417",
        "#2377a2",
        "#f3ac76",
        "#917214",
        "#96ded1",
        "#000000",
        "#167f71",
        "#191970",
        "#747880",
        "#507389",
        "#EBA83A",
        "#0BC198",
        "#004B23",
        "#867AE9",
        "#1C045C",
        "#50808E",
        "#C449C2",
        "#423F62",
        "#E500A4",
        "#064420",
        "#3C78ED",
        "#A100F2",
        "#FC5404",
        "#B25A65",
        "#08BB90",
        "#1EAE98",
        "#204969",
        "#A5BE00",
        "#4AA96C",
        "#CA3E47",
        "#7678ED",
        "#939B62",
        "#A64942",
        "#0A85ED",
        "#FFB26B",
        "#2EC4B6",
        "#D7816A",
        "#4A503D",
        "#240046",
        "#EE4266",
        "#E28F83",
        "#9D4EDD",
        "#0EAD69",
        "#3F3697",
        "#892B64",
        "#1DD3B0",
        "#3EDBF0",
        "#F94144",
        "#5C6854",
        "#F21170",
        "#E09F3E",
        "#F27F34",
        "#02475E",
        "#FF6D00",
        "#FF8C90",
        "#C67ACE",
        "#358F80",
        "#2E7094",
        "#0061A8",
        "#2B9348",
        "#73A280",
        "#7B6079",
        "#583101",
        "#921818",
        "#FF96AD",
        "#200A84",
        "#007200",
        "#005A8D",
        "#3D6C73",
        "#A2873C",
        "#00EAD3",
        "#2E4952",
        "#61574B",
        "#0A81AB",
        "#D65131",
        "#FFA5AB",
        "#FF449F",
        "#743C2C",
        "#DA627D",
        "#BB371A",
        "#1584D4",
        "#A53860",
        "#4A1C40",
        "#716AA0",
        "#754F5B",
        "#E798AE",
        "#E44477",
        "#E2711D",
        "#185ADB",
        "#4DC242",
        "#5BC0BE",
        "#99154E",
        "#FF6682",
        "#00B2CA",
        "#CF0000",
        "#5239E0",
        "#72147E",
        "#69A297",
    ],
    COLOR_ARRAY: [
        {label: '#1d873f', value: '#1d873f'},
        {label: '#0f7fff', value: '#0f7fff'},
        {label: '#ffa801', value: '#ffa801'},
        {label: '#fe6f5e', value: '#fe6f5e'},
        {label: '#747880', value: '#747880'},
        {label: '#8e3b99', value: '#8e3b99'},
        {label: '#618b8c', value: '#618b8c'},
        {label: '#ff55a3', value: '#ff55a3'},
        {label: '#009e60', value: '#009e60'},
        {label: '#DF73FF', value: '#DF73FF'},
        {label: '#ffb871', value: '#ffb871'},
        {label: '#6495ed', value: '#6495ed'},
        {label: '#45b1e8', value: '#45b1e8'},
        {label: '#77dd77', value: '#77dd77'},
        {label: '#9c8e8e', value: '#9c8e8e'},
        {label: '#7F5417', value: '#7F5417'},
        {label: '#2377a2', value: '#2377a2'},
        {label: '#f3ac76', value: '#f3ac76'},
        {label: '#917214', value: '#917214'},
        {label: '#96ded1', value: '#96ded1'},
        {label: '#000000', value: '#000000'},
        {label: '#167f71', value: '#167f71'},
        {label: '#191970', value: '#191970'},
        {label: '#fe6f5e', value: '#fe6f5e'},
        {label: '#747880', value: '#747880'},
        {label: '#507389', value: '#507389'},
        {label: '#FFA700', value: '#FFA700'},
        {label: '#007AFF', value: '#007AFF'},
    ],
    Frequency: [
        {label: 'Daily', value: 2},
        {label: 'Weekly', value: 3},
        {label: 'Monthly', value: 4},
    ],
    SKILLS_OPTIONS: [
        {value: 'poor', label: 'Poor'},
        {value: 'good', label: 'Good'},
        {value: 'excellent', label: 'Excellent'},
    ],
    LANGUAGES: [
        {code: "ab", name: "Abkhaz", nativeName: "аҧсуа"},
        {code: "aa", name: "Afar", nativeName: "Afaraf"},
        {code: "af", name: "Afrikaans", nativeName: "Afrikaans"},
        {code: "ak", name: "Akan", nativeName: "Akan"},
        {code: "sq", name: "Albanian", nativeName: "Shqip"},
        {code: "am", name: "Amharic", nativeName: "አማርኛ"},
        {code: "ar", name: "Arabic", nativeName: "العربية"},
        {code: "an", name: "Aragonese", nativeName: "Aragonés"},
        {code: "hy", name: "Armenian", nativeName: "Հայերեն"},
        {code: "as", name: "Assamese", nativeName: "অসমীয়া"},
        {code: "av", name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ"},
        {code: "ae", name: "Avestan", nativeName: "avesta"},
        {code: "ay", name: "Aymara", nativeName: "aymar aru"},
        {code: "az", name: "Azerbaijani", nativeName: "azərbaycan dili"},
        {code: "bm", name: "Bambara", nativeName: "bamanankan"},
        {code: "ba", name: "Bashkir", nativeName: "башҡорт теле"},
        {code: "eu", name: "Basque", nativeName: "euskara, euskera"},
        {code: "be", name: "Belarusian", nativeName: "Беларуская"},
        {code: "bn", name: "Bengali", nativeName: "বাংলা"},
        {code: "bh", name: "Bihari", nativeName: "भोजपुरी"},
        {code: "bi", name: "Bislama", nativeName: "Bislama"},
        {code: "bs", name: "Bosnian", nativeName: "bosanski jezik"},
        {code: "br", name: "Breton", nativeName: "brezhoneg"},
        {code: "bg", name: "Bulgarian", nativeName: "български език"},
        {code: "my", name: "Burmese", nativeName: "ဗမာစာ"},
        {code: "ca", name: "Catalan; Valencian", nativeName: "Català"},
        {code: "ch", name: "Chamorro", nativeName: "Chamoru"},
        {code: "ce", name: "Chechen", nativeName: "нохчийн мотт"},
        {
            code: "ny",
            name: "Chichewa; Chewa; Nyanja",
            nativeName: "chiCheŵa, chinyanja",
        },
        {code: "zh", name: "Chinese", nativeName: "中文 (Zhōngwén), 汉语, 漢語"},
        {code: "cv", name: "Chuvash", nativeName: "чӑваш чӗлхи"},
        {code: "kw", name: "Cornish", nativeName: "Kernewek"},
        {code: "co", name: "Corsican", nativeName: "corsu, lingua corsa"},
        {code: "cr", name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ"},
        {code: "hr", name: "Croatian", nativeName: "hrvatski"},
        {code: "cs", name: "Czech", nativeName: "česky, čeština"},
        {code: "da", name: "Danish", nativeName: "dansk"},
        {code: "dv", name: "Divehi; Dhivehi; Maldivian;", nativeName: "ދިވެހި"},
        {code: "nl", name: "Dutch", nativeName: "Nederlands, Vlaams"},
        {code: "en", name: "English", nativeName: "English"},
        {code: "eo", name: "Esperanto", nativeName: "Esperanto"},
        {code: "et", name: "Estonian", nativeName: "eesti, eesti keel"},
        {code: "ee", name: "Ewe", nativeName: "Eʋegbe"},
        {code: "fo", name: "Faroese", nativeName: "føroyskt"},
        {code: "fj", name: "Fijian", nativeName: "vosa Vakaviti"},
        {code: "fi", name: "Finnish", nativeName: "suomi, suomen kieli"},
        {code: "fr", name: "French", nativeName: "français, langue française"},
        {
            code: "ff",
            name: "Fula; Fulah; Pulaar; Pular",
            nativeName: "Fulfulde, Pulaar, Pular",
        },
        {code: "gl", name: "Galician", nativeName: "Galego"},
        {code: "ka", name: "Georgian", nativeName: "ქართული"},
        {code: "de", name: "German", nativeName: "Deutsch"},
        {code: "el", name: "Greek, Modern", nativeName: "Ελληνικά"},
        {code: "gn", name: "Guaraní", nativeName: "Avañeẽ"},
        {code: "gu", name: "Gujarati", nativeName: "ગુજરાતી"},
        {
            code: "ht",
            name: "Haitian; Haitian Creole",
            nativeName: "Kreyòl ayisyen",
        },
        {code: "ha", name: "Hausa", nativeName: "Hausa, هَوُسَ"},
        {code: "he", name: "Hebrew (modern)", nativeName: "עברית"},
        {code: "hz", name: "Herero", nativeName: "Otjiherero"},
        {code: "hi", name: "Hindi", nativeName: "हिन्दी, हिंदी"},
        {code: "ho", name: "Hiri Motu", nativeName: "Hiri Motu"},
        {code: "hu", name: "Hungarian", nativeName: "Magyar"},
        {code: "ia", name: "Interlingua", nativeName: "Interlingua"},
        {code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia"},
        {
            code: "ie",
            name: "Interlingue",
            nativeName: "Originally called Occidental; then Interlingue after WWII",
        },
        {code: "ga", name: "Irish", nativeName: "Gaeilge"},
        {code: "ig", name: "Igbo", nativeName: "Asụsụ Igbo"},
        {code: "ik", name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun"},
        {code: "io", name: "Ido", nativeName: "Ido"},
        {code: "is", name: "Icelandic", nativeName: "Íslenska"},
        {code: "it", name: "Italian", nativeName: "Italiano"},
        {code: "iu", name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ"},
        {
            code: "ja",
            name: "Japanese",
            nativeName: "日本語 (にほんご／にっぽんご)",
        },
        {code: "jv", name: "Javanese", nativeName: "basa Jawa"},
        {
            code: "kl",
            name: "Kalaallisut, Greenlandic",
            nativeName: "kalaallisut, kalaallit oqaasii",
        },
        {code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ"},
        {code: "kr", name: "Kanuri", nativeName: "Kanuri"},
        {code: "ks", name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎"},
        {code: "kk", name: "Kazakh", nativeName: "Қазақ тілі"},
        {code: "km", name: "Khmer", nativeName: "ភាសាខ្មែរ"},
        {code: "ki", name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ"},
        {code: "rw", name: "Kinyarwanda", nativeName: "Ikinyarwanda"},
        {code: "ky", name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили"},
        {code: "kv", name: "Komi", nativeName: "коми кыв"},
        {code: "kg", name: "Kongo", nativeName: "KiKongo"},
        {
            code: "ko",
            name: "Korean",
            nativeName: "한국어 (韓國語), 조선말 (朝鮮語)",
        },
        {code: "ku", name: "Kurdish", nativeName: "Kurdî, كوردی‎"},
        {code: "kj", name: "Kwanyama, Kuanyama", nativeName: "Kuanyama"},
        {code: "la", name: "Latin", nativeName: "latine, lingua latina"},
        {
            code: "lb",
            name: "Luxembourgish, Letzeburgesch",
            nativeName: "Lëtzebuergesch",
        },
        {code: "lg", name: "Luganda", nativeName: "Luganda"},
        {
            code: "li",
            name: "Limburgish, Limburgan, Limburger",
            nativeName: "Limburgs",
        },
        {code: "ln", name: "Lingala", nativeName: "Lingála"},
        {code: "lo", name: "Lao", nativeName: "ພາສາລາວ"},
        {code: "lt", name: "Lithuanian", nativeName: "lietuvių kalba"},
        {code: "lu", name: "Luba-Katanga", nativeName: ""},
        {code: "lv", name: "Latvian", nativeName: "latviešu valoda"},
        {code: "gv", name: "Manx", nativeName: "Gaelg, Gailck"},
        {code: "mk", name: "Macedonian", nativeName: "македонски јазик"},
        {code: "mg", name: "Malagasy", nativeName: "Malagasy fiteny"},
        {code: "ms", name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎"},
        {code: "ml", name: "Malayalam", nativeName: "മലയാളം"},
        {code: "mt", name: "Maltese", nativeName: "Malti"},
        {code: "mi", name: "Māori", nativeName: "te reo Māori"},
        {code: "mr", name: "Marathi (Marāṭhī)", nativeName: "मराठी"},
        {code: "mh", name: "Marshallese", nativeName: "Kajin M̧ajeļ"},
        {code: "mn", name: "Mongolian", nativeName: "монгол"},
        {code: "na", name: "Nauru", nativeName: "Ekakairũ Naoero"},
        {
            code: "nv",
            name: "Navajo, Navaho",
            nativeName: "Diné bizaad, Dinékʼehǰí",
        },
        {code: "nb", name: "Norwegian Bokmål", nativeName: "Norsk bokmål"},
        {code: "nd", name: "North Ndebele", nativeName: "isiNdebele"},
        {code: "ne", name: "Nepali", nativeName: "नेपाली"},
        {code: "ng", name: "Ndonga", nativeName: "Owambo"},
        {code: "nn", name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk"},
        {code: "no", name: "Norwegian", nativeName: "Norsk"},
        {code: "ii", name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop"},
        {code: "nr", name: "South Ndebele", nativeName: "isiNdebele"},
        {code: "oc", name: "Occitan", nativeName: "Occitan"},
        {code: "oj", name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ"},
        {
            code: "cu",
            name:
                "Old Church Slavonic",
            nativeName: "ѩзыкъ словѣньскъ",
        },
        {code: "om", name: "Oromo", nativeName: "Afaan Oromoo"},
        {code: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ"},
        {code: "os", name: "Ossetian, Ossetic", nativeName: "ирон æвзаг"},
        {code: "pa", name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎"},
        {code: "pi", name: "Pāli", nativeName: "पाऴि"},
        {code: "fa", name: "Persian", nativeName: "فارسی"},
        {code: "pl", name: "Polish", nativeName: "polski"},
        {code: "ps", name: "Pashto, Pushto", nativeName: "پښتو"},
        {code: "pt", name: "Portuguese", nativeName: "Português"},
        {code: "qu", name: "Quechua", nativeName: "Runa Simi, Kichwa"},
        {code: "rm", name: "Romansh", nativeName: "rumantsch grischun"},
        {code: "rn", name: "Kirundi", nativeName: "kiRundi"},
        {code: "ro", name: "Romanian, Moldavian, Moldovan", nativeName: "română"},
        {code: "ru", name: "Russian", nativeName: "русский язык"},
        {code: "sa", name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्"},
        {code: "sc", name: "Sardinian", nativeName: "sardu"},
        {code: "sd", name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎"},
        {code: "se", name: "Northern Sami", nativeName: "Davvisámegiella"},
        {code: "sm", name: "Samoan", nativeName: "gagana faa Samoa"},
        {code: "sg", name: "Sango", nativeName: "yângâ tî sängö"},
        {code: "sr", name: "Serbian", nativeName: "српски језик"},
        {code: "gd", name: "Scottish Gaelic; Gaelic", nativeName: "Gàidhlig"},
        {code: "sn", name: "Shona", nativeName: "chiShona"},
        {code: "si", name: "Sinhala, Sinhalese", nativeName: "සිංහල"},
        {code: "sk", name: "Slovak", nativeName: "slovenčina"},
        {code: "sl", name: "Slovene", nativeName: "slovenščina"},
        {code: "so", name: "Somali", nativeName: "Soomaaliga, af Soomaali"},
        {code: "st", name: "Southern Sotho", nativeName: "Sesotho"},
        {
            code: "es",
            name: "Spanish; Castilian",
            nativeName: "español, castellano",
        },
        {code: "su", name: "Sundanese", nativeName: "Basa Sunda"},
        {code: "sw", name: "Swahili", nativeName: "Kiswahili"},
        {code: "ss", name: "Swati", nativeName: "SiSwati"},
        {code: "sv", name: "Swedish", nativeName: "svenska"},
        {code: "ta", name: "Tamil", nativeName: "தமிழ்"},
        {code: "te", name: "Telugu", nativeName: "తెలుగు"},
        {code: "tg", name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎"},
        {code: "th", name: "Thai", nativeName: "ไทย"},
        {code: "ti", name: "Tigrinya", nativeName: "ትግርኛ"},
        {
            code: "bo",
            name: "Tibetan Standard, Tibetan, Central",
            nativeName: "བོད་ཡིག",
        },
        {code: "tk", name: "Turkmen", nativeName: "Türkmen, Түркмен"},
        {code: "tl", name: "Tagalog", nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"},
        {code: "tn", name: "Tswana", nativeName: "Setswana"},
        {code: "to", name: "Tonga (Tonga Islands)", nativeName: "faka Tonga"},
        {code: "tr", name: "Turkish", nativeName: "Türkçe"},
        {code: "ts", name: "Tsonga", nativeName: "Xitsonga"},
        {code: "tt", name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎"},
        {code: "tw", name: "Twi", nativeName: "Twi"},
        {code: "ty", name: "Tahitian", nativeName: "Reo Tahiti"},
        {code: "ug", name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎"},
        {code: "uk", name: "Ukrainian", nativeName: "українська"},
        {code: "ur", name: "Urdu", nativeName: "اردو"},
        {code: "uz", name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎"},
        {code: "ve", name: "Venda", nativeName: "Tshivenḓa"},
        {code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt"},
        {code: "vo", name: "Volapük", nativeName: "Volapük"},
        {code: "wa", name: "Walloon", nativeName: "Walon"},
        {code: "cy", name: "Welsh", nativeName: "Cymraeg"},
        {code: "wo", name: "Wolof", nativeName: "Wollof"},
        {code: "fy", name: "Western Frisian", nativeName: "Frysk"},
        {code: "xh", name: "Xhosa", nativeName: "isiXhosa"},
        {code: "yi", name: "Yiddish", nativeName: "ייִדיש"},
        {code: "yo", name: "Yoruba", nativeName: "Yorùbá"},
        {code: "za", name: "Zhuang, Chuang", nativeName: "Saɯ cueŋƅ, Saw cuengh"},
    ],
    optionsList: [
        {
            label: 'Single line text',
            image: <Icon.Minus size={18} fill={COLOR.u_title}/>,
            value: 'singleline',
            question: ``,
            hint: ``,
            type: 1,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Multi line text',
            image: <Icon.Multiline size={18} fill={COLOR.u_title}/>,
            value: 'multiline',
            question: ``,
            hint: ``,
            type: 2,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Yes/No',
            image: <Icon.YesNo size={18} fill={COLOR.u_title}/>,
            value: 'yes/no',
            question: ``,
            hint: ``,
            type: 3,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Single choice',
            image: <Icon.CheckMark size={18} fill={COLOR.u_title}/>,
            value: 'singlechoice',
            question: ``,
            hint: ``,
            type: 4,
            required: false,
            isSection: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Answer 1",
                value: "Answer 1"
            }, {
                label: "Answer 2",
                value: "Answer 2"
            }]
        },
        {
            label: 'Multiple choice',
            image: <Icon.DoubleTick size={18} fill={COLOR.u_title}/>,
            value: 'multiplechoise',
            question: ``,
            hint: ``,
            type: 5,
            required: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Answer 1",
                value: "Answer 1"
            }, {
                label: "Answer 2",
                value: "Answer 2"
            }],
        },
        {
            label: 'Dropdown',
            image: <Icon.ListData size={18} fill={COLOR.u_title}/>,
            value: 'dropdown',
            question: ``,
            hint: ``,
            type: 6,
            required: false,
            isSection: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Answer 1",
                value: "Answer 1"
            }, {
                label: "Answer 2",
                value: "Answer 2"
            }]
        },
        {
            label: 'Gender',
            image: <Icon.Gender size={18} fill={COLOR.u_title}/>,
            value: 'gender',
            question: ``,
            hint: ``,
            type: 7,
            required: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Male",
                value: "Male"
            }, {
                label: "Female",
                value: "Female"
            }]
        },
        {
            label: 'Email',
            image: <Icon.Mail size={18} fill={COLOR.u_title}/>,
            value: 'email',
            question: ``,
            hint: ``,
            type: 8,
            required: false,
            errorMessage: 'This question is mandatory',
        },
        {
            label: 'Number',
            image: <Icon.ListData size={18} fill={COLOR.u_title}/>,
            value: 'number',
            question: ``,
            hint: ``,
            type: 9,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Date',
            image: <Icon.Calendar size={18} fill={COLOR.u_title}/>,
            value: 'date',
            question: ``,
            hint: ``,
            type: 10,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Address',
            image: <Icon.Location size={18} fill={COLOR.u_title}/>,
            value: 'address',
            question: ``,
            hint: ``,
            type: 11,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Slider scale',
            image: <Icon.CozyView size={18} fill={COLOR.u_title}/>,
            value: 'sliderscale',
            question: ``,
            hint: ``,
            type: 12,
            required: false,
            start: "",
            end: "",
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Star rating',
            image: <Icon.StarFill size={18} fill={COLOR.u_title}/>,
            value: 'starrating',
            question: ``,
            hint: ``,
            type: 13,
            required: false,
            NA: false,
            errorMessage: 'This question is mandatory',
            noOfRange: 0,
            rating: [
                {value: 5, label: '05'},
                {value: 10, label: '10'}
            ]
        },
        {
            label: 'NPS',
            image: <Icon.NPS size={18} fill={COLOR.u_title}/>,
            value: 'nps',
            question: ``,
            hint: ``,
            startScale: ``,
            endScale: ``,
            type: 14,
            required: false,
            notApplicable: false,
            errorMessage: 'This question is mandatory',
            optionList1: [
                {value: 'Smileys', label: 'Smileys'},
                {value: 'Boxes', label: 'Boxes'},
                {value: 'Circles', label: 'Circles'}
            ],
            optionList2: [
                {value: '2color', label: '😀', link: `Smileys`},
                {value: '3color', label: '3 Colors', link: `Smileys`},
                {value: 'customcolor', label: 'Custom Colors', link: `Smileys`},
                {value: 'Boxes', label: 'Boxes', link: `Boxes`},
                {value: 'Boxes', label: 'Boxes', link: `Boxes`},
                {value: 'Circles', label: 'Circles', link: `Circles`},
                {value: 'Circles', label: 'Circles', link: `Circles`}
            ]
        },
        {
            label: 'Info box',
            image: <Icon.InfoTooltip size={18} fill={COLOR.u_title}/>,
            value: 'infobox',
            question: ``,
            content: ``,
            type: 15,
            required: false,
            errorMessage: ''
        },
        {
            label: 'Heading/Description',
            image: <Icon.NoTask size={18} fill={COLOR.u_title}/>,
            value: 'headingdesc',
            heading: ``,
            comment: ``,
            type: 16,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'File Upload',
            image: <Icon.Upload size={18} fill={COLOR.u_title}/>,
            value: 'fileupload',
            question: ``,
            hint: ``,
            type: 17,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Scorecard',
            image: <Icon.NotSure size={18} fill={COLOR.u_title}/>,
            value: 'scorecard',
            question: ``,
            hint: ``,
            type: 18,
            required: false,
            errorMessage: 'This question is mandatory',
            isOtherOption: false,
            menuOptions: [{
                label: "",
                value: ""
            }, {
                label: "",
                value: ""
            }],
        },
    ],
    MONTHFREQUENCY: [
        {label: 'Select Days', value: ''},
        {label: 'Annual day', value: 1},
        {label: 'Monthly on the second Tuesday', value: 2},
    ],
    AnalyticsFrequency: [
        {label: 'Today', value: 1},
        {label: 'Weekly', value: 2},
        {label: 'Monthly', value: 3},
        {label: 'Yearly', value: 4},
    ],
    GENDER: [
        {"value": 1, "label": "Male"},
        {"value": 2, "label": "Female"},
        {"value": 3, "label": "Other"},
        {"value": 4, "label": "Transgender"},
    ],
    GENDER_LIST: [
        {"value": 'male', "label": "Male"},
        {"value": 'female', "label": "Female"},
        {"value": 'other', "label": "Other"},
        {"value": 'transgender', "label": "Transgender"},
    ],
    MARITAL_STATUS: [
        {label: "Married", value: 1},
        {label: "Unmarried", value: 2},
        {label: "Divorced", value: 2},
        {label: "Widowed", value: 3},
        {label: "Other", value: 4},
    ],
    MARITAL_STATUS_LIST: [
        {label: "Married", value: "married"},
        {label: "Unmarried", value: "unmarried"},
        {label: "Divorced", value: "divorced"},
        {label: "Widowed", value: "widowed"},
        {label: "Other", value: "other"},
    ],
    TASK_DUE_DATE: [
        {value: 'beforeToday', label: 'Before today'},
        {value: 'today', label: 'Today'},
        {value: 'tomorrow', label: 'Tomorrow'},
        {value: 'thisWeek', label: 'This week'},
        {value: 'nextWeek', label: 'Next week'},
        {value: 'next14', label: 'Next 14 days'},
        {value: 'customDate', label: 'Custom Date'},
    ],
    RECURRENCE_TYPE: {
        DAILY: 1,
        WEEKLY: 2,
        MONTHLY: 3,
        YEARLY: 4,
        PERIODICALLY: 5,
        CUSTOM: 6,
        CUSTOM_WEEKLY: 2,
        CUSTOM_MONTHLY: 3,
    },
    RECURRENCE_TYPE_LIST: [
        {label: 'Daily', value: 1},
        {label: 'Weekly', value: 2},
        {label: 'Monthly', value: 3},
        {label: 'Yearly', value: 4},
        {label: 'Periodically', value: 5},
        {label: 'Custom', value: 6},
    ],
    EVERY_TYPE: [
        {label: 'Weekly', value: 2},
        {label: 'Monthly', value: 3},
    ],
    DAY: [
        {label: 'Su', value: 0, checked: false},
        {label: 'Mo', value: 1, checked: false},
        {label: 'Tu', value: 2, checked: false},
        {label: 'We', value: 3, checked: false},
        {label: 'Th', value: 4, checked: false},
        {label: 'Fr', value: 5, checked: false},
        {label: 'Sa', value: 6, checked: false},
    ],
    EVERY_DAY: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: 4, value: 4},
        {label: 5, value: 5},
        {label: 6, value: 6},
        {label: 7, value: 7},
        {label: 8, value: 8},
        {label: 9, value: 9},
        {label: 10, value: 10},
        {label: 11, value: 11},
        {label: 12, value: 12},
    ],
    ON_DAY: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: 4, value: 4},
        {label: 5, value: 5},
        {label: 6, value: 6},
        {label: 7, value: 7},
        {label: 8, value: 8},
        {label: 9, value: 9},
        {label: 10, value: 10},
        {label: 11, value: 11},
        {label: 12, value: 12},
        {label: 13, value: 13},
        {label: 14, value: 14},
        {label: 15, value: 15},
        {label: 16, value: 16},
        {label: 17, value: 17},
        {label: 18, value: 18},
        {label: 19, value: 19},
        {label: 20, value: 20},
        {label: 21, value: 21},
        {label: 22, value: 22},
        {label: 23, value: 23},
        {label: 24, value: 24},
        {label: 25, value: 25},
        {label: 26, value: 26},
        {label: 27, value: 27},
        {label: 28, value: 28},
        {label: 'Last', value: 'last'},
    ],
    DAYS_AFTER_COMPLETION: [
        {label: 1, value: 1},
        {label: 2, value: 2},
        {label: 3, value: 3},
        {label: 4, value: 4},
        {label: 5, value: 5},
        {label: 6, value: 6},
        {label: 7, value: 7},
        {label: 8, value: 8},
        {label: 9, value: 9},
        {label: 10, value: 10},
        {label: 11, value: 11},
        {label: 12, value: 12},
        {label: 13, value: 13},
        {label: 14, value: 14},
        {label: 15, value: 15},
        {label: 16, value: 16},
        {label: 17, value: 17},
        {label: 18, value: 18},
        {label: 19, value: 19},
        {label: 20, value: 20},
        {label: 21, value: 21},
        {label: 22, value: 22},
        {label: 23, value: 23},
        {label: 24, value: 24},
        {label: 25, value: 25},
        {label: 26, value: 26},
        {label: 27, value: 27},
        {label: 28, value: 28},
        {label: 29, value: 29},
        {label: 30, value: 30},
    ],
    COUNTRY_CODE: [
        {"name": "Afghanistan", "label": "Afghanistan", "dial_code": "+93", "code": "AF"},
        {"name": "Aland Islands", "label": "Aland Islands", "dial_code": "+358", "code": "AX"},
        {"name": "Albania", "label": "Albania", "dial_code": "+355", "code": "AL"},
        {"name": "Algeria", "label": "Algeria", "dial_code": "+213", "code": "DZ"},
        {"name": "Canada", "label": "Canada", "dial_code": "+1", "code": "CA"},
        {"name": "AmericanSamoa", "label": "AmericanSamoa", "dial_code": "+1684", "code": "AS"},
        {"name": "Andorra", "label": "Andorra", "dial_code": "+376", "code": "AD"},
        {"name": "Angola", "label": "Angola", "dial_code": "+244", "code": "AO"},
        {"name": "Anguilla", "label": "Anguilla", "dial_code": "+1264", "code": "AI"},
        {"name": "Antarctica", "label": "Antarctica", "dial_code": "+672", "code": "AQ"},
        {"name": "Antigua and Barbuda", "label": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG"},
        {"name": "Argentina", "label": "Argentina", "dial_code": "+54", "code": "AR"},
        {"name": "Armenia", "label": "Armenia", "dial_code": "+374", "code": "AM"},
        {"name": "Aruba", "label": "Aruba", "dial_code": "+297", "code": "AW"},
        {"name": "Australia", "label": "Australia", "dial_code": "+61", "code": "AU"},
        {"name": "Austria", "label": "Austria", "dial_code": "+43", "code": "AT"},
        {"name": "Azerbaijan", "label": "Azerbaijan", "dial_code": "+994", "code": "AZ"},
        {"name": "Bahamas", "label": "Bahamas", "dial_code": "+1242", "code": "BS"},
        {"name": "Bahrain", "label": "Bahrain", "dial_code": "+973", "code": "BH"},
        {"name": "Bangladesh", "label": "Bangladesh", "dial_code": "+880", "code": "BD"},
        {"name": "Barbados", "label": "Barbados", "dial_code": "+1246", "code": "BB"},
        {"name": "Belarus", "label": "Belarus", "dial_code": "+375", "code": "BY"},
        {"name": "Belgium", "label": "Belgium", "dial_code": "+32", "code": "BE"},
        {"name": "Belize", "label": "Belize", "dial_code": "+501", "code": "BZ"},
        {"name": "Benin", "label": "Benin", "dial_code": "+229", "code": "BJ"},
        {"name": "Bermuda", "label": "Bermuda", "dial_code": "+1441", "code": "BM"},
        {"name": "Bhutan", "label": "Bhutan", "dial_code": "+975", "code": "BT"},
        {
            "name": "Bolivia, Plurinational State of",
            "label": "Bolivia, Plurinational State of",
            "dial_code": "+591",
            "code": "BO"
        },
        {"name": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA"},
        {"name": "Botswana", "label": "Botswana", "dial_code": "+267", "code": "BW"},
        {"name": "Brazil", "label": "Brazil", "dial_code": "+55", "code": "BR"},
        {
            "name": "British Indian Ocean Territory",
            "label": "British Indian Ocean Territory",
            "dial_code": "+246",
            "code": "IO"
        },
        {"name": "Brunei Darussalam", "label": "Brunei Darussalam", "dial_code": "+673", "code": "BN"},
        {"name": "Bulgaria", "label": "Bulgaria", "dial_code": "+359", "code": "BG"},
        {"name": "Burkina Faso", "label": "Burkina Faso", "dial_code": "+226", "code": "BF"},
        {"name": "Burundi", "label": "Burundi", "dial_code": "+257", "code": "BI"},
        {"name": "Cambodia", "label": "Cambodia", "dial_code": "+855", "code": "KH"},
        {"name": "Cameroon", "label": "Cameroon", "dial_code": "+237", "code": "CM"},

        {"name": "Cape Verde", "label": "Cape Verde", "dial_code": "+238", "code": "CV"},
        {"name": "Cayman Islands", "label": "Cayman Islands", "dial_code": "+ 345", "code": "KY"},
        {"name": "Central African Republic", "label": "Central African Republic", "dial_code": "+236", "code": "CF"},
        {"name": "Chad", "label": "Chad", "dial_code": "+235", "code": "TD"},
        {"name": "Chile", "label": "Chile", "dial_code": "+56", "code": "CL"},
        {"name": "China", "label": "China", "dial_code": "+86", "code": "CN"},
        {"name": "Christmas Island", "label": "Christmas Island", "dial_code": "+61", "code": "CX"},
        {"name": "Cocos (Keeling) Islands", "label": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC"},
        {"name": "Colombia", "label": "Colombia", "dial_code": "+57", "code": "CO"},
        {"name": "Comoros", "label": "Comoros", "dial_code": "+269", "code": "KM"},
        {"name": "Congo", "label": "Congo", "dial_code": "+242", "code": "CG"},
        {
            "name": "Congo, The Democratic Republic of the Congo",
            "label": "Congo, The Democratic Republic of the Congo",
            "dial_code": "+243",
            "code": "CD"
        },
        {"name": "Cook Islands", "label": "Cook Islands", "dial_code": "+682", "code": "CK"},
        {"name": "Costa Rica", "label": "Costa Rica", "dial_code": "+506", "code": "CR"},
        {"name": "Cote d'Ivoire", "label": "Cote d'Ivoire", "dial_code": "+225", "code": "CI"},
        {"name": "Croatia", "label": "Croatia", "dial_code": "+385", "code": "HR"},
        {"name": "Cuba", "label": "Cuba", "dial_code": "+53", "code": "CU"},
        {"name": "Cyprus", "label": "Cyprus", "dial_code": "+357", "code": "CY"},
        {"name": "Czech Republic", "label": "Czech Republic", "dial_code": "+420", "code": "CZ"},
        {"name": "Denmark", "label": "Denmark", "dial_code": "+45", "code": "DK"},
        {"name": "Djibouti", "label": "Djibouti", "dial_code": "+253", "code": "DJ"},
        {"name": "Dominica", "label": "Dominica", "dial_code": "+1767", "code": "DM"},
        {"name": "Dominican Republic", "label": "Dominican Republic", "dial_code": "+1849", "code": "DO"},
        {"name": "Ecuador", "label": "Ecuador", "dial_code": "+593", "code": "EC"},
        {"name": "Egypt", "label": "Egypt", "dial_code": "+20", "code": "EG"},
        {"name": "El Salvador", "label": "El Salvador", "dial_code": "+503", "code": "SV"},
        {"name": "Equatorial Guinea", "label": "Equatorial Guinea", "dial_code": "+240", "code": "GQ"},
        {"name": "Eritrea", "label": "Eritrea", "dial_code": "+291", "code": "ER"},
        {"name": "Estonia", "label": "Estonia", "dial_code": "+372", "code": "EE"},
        {"name": "Ethiopia", "label": "Ethiopia", "dial_code": "+251", "code": "ET"},
        {
            "name": "Falkland Islands (Malvinas)",
            "label": "Falkland Islands (Malvinas)",
            "dial_code": "+500",
            "code": "FK"
        },
        {"name": "Faroe Islands", "label": "Faroe Islands", "dial_code": "+298", "code": "FO"},
        {"name": "Fiji", "label": "Fiji", "dial_code": "+679", "code": "FJ"},
        {"name": "Finland", "label": "Finland", "dial_code": "+358", "code": "FI"},
        {"name": "France", "label": "France", "dial_code": "+33", "code": "FR"},
        {"name": "French Guiana", "label": "French Guiana", "dial_code": "+594", "code": "GF"},
        {"name": "French Polynesia", "label": "French Polynesia", "dial_code": "+689", "code": "PF"},
        {"name": "Gabon", "label": "Gabon", "dial_code": "+241", "code": "GA"},
        {"name": "Gambia", "label": "Gambia", "dial_code": "+220", "code": "GM"},
        {"name": "Georgia", "label": "Georgia", "dial_code": "+995", "code": "GE"},
        {"name": "Germany", "label": "Germany", "dial_code": "+49", "code": "DE"},
        {"name": "Ghana", "label": "Ghana", "dial_code": "+233", "code": "GH"},
        {"name": "Gibraltar", "label": "Gibraltar", "dial_code": "+350", "code": "GI"},
        {"name": "Greece", "label": "Greece", "dial_code": "+30", "code": "GR"},
        {"name": "Greenland", "label": "Greenland", "dial_code": "+299", "code": "GL"},
        {"name": "Grenada", "label": "Grenada", "dial_code": "+1473", "code": "GD"},
        {"name": "Guadeloupe", "label": "Guadeloupe", "dial_code": "+590", "code": "GP"},
        {"name": "Guam", "label": "Guam", "dial_code": "+1671", "code": "GU"},
        {"name": "Guatemala", "label": "Guatemala", "dial_code": "+502", "code": "GT"},
        {"name": "Guernsey", "label": "Guernsey", "dial_code": "+44", "code": "GG"},
        {"name": "Guinea", "label": "Guinea", "dial_code": "+224", "code": "GN"},
        {"name": "Guinea-Bissau", "label": "Guinea-Bissau", "dial_code": "+245", "code": "GW"},
        {"name": "Guyana", "label": "Guyana", "dial_code": "+595", "code": "GY"},
        {"name": "Haiti", "label": "Haiti", "dial_code": "+509", "code": "HT"},
        {
            "name": "Holy See (Vatican City State)",
            "label": "Holy See (Vatican City State)",
            "dial_code": "+379",
            "code": "VA"
        },
        {"name": "Honduras", "label": "Honduras", "dial_code": "+504", "code": "HN"},
        {"name": "Hong Kong", "label": "Hong Kong", "dial_code": "+852", "code": "HK"},
        {"name": "Hungary", "label": "Hungary", "dial_code": "+36", "code": "HU"},
        {"name": "Iceland", "label": "Iceland", "dial_code": "+354", "code": "IS"},
        {"name": "India", "label": "India", "dial_code": "+91", "code": "IN"},
        {"name": "Indonesia", "label": "Indonesia", "dial_code": "+62", "code": "ID"},
        {
            "name": "Iran, Islamic Republic of Persian Gulf",
            "label": "Iran, Islamic Republic of Persian Gulf",
            "dial_code": "+98",
            "code": "IR"
        },
        {"name": "Iraq", "label": "Iraq", "dial_code": "+964", "code": "IQ"},
        {"name": "Ireland", "label": "Ireland", "dial_code": "+353", "code": "IE"},
        {"name": "Isle of Man", "label": "Isle of Man", "dial_code": "+44", "code": "IM"},
        {"name": "Israel", "label": "Israel", "dial_code": "+972", "code": "IL"},
        {"name": "Italy", "label": "Italy", "dial_code": "+39", "code": "IT"},
        {"name": "Jamaica", "label": "Jamaica", "dial_code": "+1876", "code": "JM"},
        {"name": "Japan", "label": "Japan", "dial_code": "+81", "code": "JP"},
        {"name": "Jersey", "label": "Jersey", "dial_code": "+44", "code": "JE"},
        {"name": "Jordan", "label": "Jordan", "dial_code": "+962", "code": "JO"},
        {"name": "Kazakhstan", "label": "Kazakhstan", "dial_code": "+77", "code": "KZ"},
        {"name": "Kenya", "label": "Kenya", "dial_code": "+254", "code": "KE"},
        {"name": "Kiribati", "label": "Kiribati", "dial_code": "+686", "code": "KI"},
        {
            "name": "Korea, Democratic People's Republic of Korea",
            "label": "Korea, Democratic People's Republic of Korea",
            "dial_code": "+850",
            "code": "KP"
        },
        {
            "name": "Korea, Republic of South Korea",
            "label": "Korea, Republic of South Korea",
            "dial_code": "+82",
            "code": "KR"
        },
        {"name": "Kuwait", "label": "Kuwait", "dial_code": "+965", "code": "KW"},
        {"name": "Kyrgyzstan", "label": "Kyrgyzstan", "dial_code": "+996", "code": "KG"},
        {"name": "Laos", "label": "Laos", "dial_code": "+856", "code": "LA"},
        {"name": "Latvia", "label": "Latvia", "dial_code": "+371", "code": "LV"},
        {"name": "Lebanon", "label": "Lebanon", "dial_code": "+961", "code": "LB"},
        {"name": "Lesotho", "label": "Lesotho", "dial_code": "+266", "code": "LS"},
        {"name": "Liberia", "label": "Liberia", "dial_code": "+231", "code": "LR"},
        {"name": "Libyan Arab Jamahiriya", "label": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY"},
        {"name": "Liechtenstein", "label": "Liechtenstein", "dial_code": "+423", "code": "LI"},
        {"name": "Lithuania", "label": "Lithuania", "dial_code": "+370", "code": "LT"},
        {"name": "Luxembourg", "label": "Luxembourg", "dial_code": "+352", "code": "LU"},
        {"name": "Macao", "label": "Macao", "dial_code": "+853", "code": "MO"},
        {"name": "Macedonia", "label": "Macedonia", "dial_code": "+389", "code": "MK"},
        {"name": "Madagascar", "label": "Madagascar", "dial_code": "+261", "code": "MG"},
        {"name": "Malawi", "label": "Malawi", "dial_code": "+265", "code": "MW"},
        {"name": "Malaysia", "label": "Malaysia", "dial_code": "+60", "code": "MY"},
        {"name": "Maldives", "label": "Maldives", "dial_code": "+960", "code": "MV"},
        {"name": "Mali", "label": "Mali", "dial_code": "+223", "code": "ML"},
        {"name": "Malta", "label": "Malta", "dial_code": "+356", "code": "MT"},
        {"name": "Marshall Islands", "label": "Marshall Islands", "dial_code": "+692", "code": "MH"},
        {"name": "Martinique", "label": "Martinique", "dial_code": "+596", "code": "MQ"},
        {"name": "Mauritania", "label": "Mauritania", "dial_code": "+222", "code": "MR"},
        {"name": "Mauritius", "label": "Mauritius", "dial_code": "+230", "code": "MU"},
        {"name": "Mayotte", "label": "Mayotte", "dial_code": "+262", "code": "YT"},
        {"name": "Mexico", "label": "Mexico", "dial_code": "+52", "code": "MX"},
        {
            "name": "Micronesia, Federated States of Micronesia",
            "label": "Micronesia, Federated States of Micronesia",
            "dial_code": "+691",
            "code": "FM"
        },
        {"name": "Moldova", "label": "Moldova", "dial_code": "+373", "code": "MD"},
        {"name": "Monaco", "label": "Monaco", "dial_code": "+377", "code": "MC"},
        {"name": "Mongolia", "label": "Mongolia", "dial_code": "+976", "code": "MN"},
        {"name": "Montenegro", "label": "Montenegro", "dial_code": "+382", "code": "ME"},
        {"name": "Montserrat", "label": "Montserrat", "dial_code": "+1664", "code": "MS"},
        {"name": "Morocco", "label": "Morocco", "dial_code": "+212", "code": "MA"},
        {"name": "Mozambique", "label": "Mozambique", "dial_code": "+258", "code": "MZ"},
        {"name": "Myanmar", "label": "Myanmar", "dial_code": "+95", "code": "MM"},
        {"name": "Namibia", "label": "Namibia", "dial_code": "+264", "code": "NA"},
        {"name": "Nauru", "label": "Nauru", "dial_code": "+674", "code": "NR"},
        {"name": "Nepal", "label": "Nepal", "dial_code": "+977", "code": "NP"},
        {"name": "Netherlands", "label": "Netherlands", "dial_code": "+31", "code": "NL"},
        {"name": "Netherlands Antilles", "label": "Netherlands Antilles", "dial_code": "+599", "code": "AN"},
        {"name": "New Caledonia", "label": "New Caledonia", "dial_code": "+687", "code": "NC"},
        {"name": "New Zealand", "label": "New Zealand", "dial_code": "+64", "code": "NZ"},
        {"name": "Nicaragua", "label": "Nicaragua", "dial_code": "+505", "code": "NI"},
        {"name": "Niger", "label": "Niger", "dial_code": "+227", "code": "NE"},
        {"name": "Nigeria", "label": "Nigeria", "dial_code": "+234", "code": "NG"},
        {"name": "Niue", "label": "Niue", "dial_code": "+683", "code": "NU"},
        {"name": "Norfolk Island", "label": "Norfolk Island", "dial_code": "+672", "code": "NF"},
        {"name": "Northern Mariana Islands", "label": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP"},
        {"name": "Norway", "label": "Norway", "dial_code": "+47", "code": "NO"},
        {"name": "Oman", "label": "Oman", "dial_code": "+968", "code": "OM"},
        {"name": "Pakistan", "label": "Pakistan", "dial_code": "+92", "code": "PK"},
        {"name": "Palau", "label": "Palau", "dial_code": "+680", "code": "PW"},
        {
            "name": "Palestinian Territory, Occupied",
            "label": "Palestinian Territory, Occupied",
            "dial_code": "+970",
            "code": "PS"
        },
        {"name": "Panama", "label": "Panama", "dial_code": "+507", "code": "PA"},
        {"name": "Papua New Guinea", "label": "Papua New Guinea", "dial_code": "+675", "code": "PG"},
        {"name": "Paraguay", "label": "Paraguay", "dial_code": "+595", "code": "PY"},
        {"name": "Peru", "label": "Peru", "dial_code": "+51", "code": "PE"},
        {"name": "Philippines", "label": "Philippines", "dial_code": "+63", "code": "PH"},
        {"name": "Pitcairn", "label": "Pitcairn", "dial_code": "+872", "code": "PN"},
        {"name": "Poland", "label": "Poland", "dial_code": "+48", "code": "PL"},
        {"name": "Portugal", "label": "Portugal", "dial_code": "+351", "code": "PT"},
        {"name": "Puerto Rico", "label": "Puerto Rico", "dial_code": "+1939", "code": "PR"},
        {"name": "Qatar", "label": "Qatar", "dial_code": "+974", "code": "QA"},
        {"name": "Romania", "label": "Romania", "dial_code": "+40", "code": "RO"},
        {"name": "Russia", "label": "Russia", "dial_code": "+7", "code": "RU"},
        {"name": "Rwanda", "label": "Rwanda", "dial_code": "+250", "code": "RW"},
        {"name": "Reunion", "label": "Reunion", "dial_code": "+262", "code": "RE"},
        {"name": "Saint Barthelemy", "label": "Saint Barthelemy", "dial_code": "+590", "code": "BL"},
        {
            "name": "Saint Helena, Ascension and Tristan Da Cunha",
            "label": "Saint Helena, Ascension and Tristan Da Cunha",
            "dial_code": "+290",
            "code": "SH"
        },
        {"name": "Saint Kitts and Nevis", "label": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN"},
        {"name": "Saint Lucia", "label": "Saint Lucia", "dial_code": "+1758", "code": "LC"},
        {"name": "Saint Martin", "label": "Saint Martin", "dial_code": "+590", "code": "MF"},
        {"name": "Saint Pierre and Miquelon", "label": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM"},
        {
            "name": "Saint Vincent and the Grenadines",
            "label": "Saint Vincent and the Grenadines",
            "dial_code": "+1784",
            "code": "VC"
        },
        {"name": "Samoa", "label": "Samoa", "dial_code": "+685", "code": "WS"},
        {"name": "San Marino", "label": "San Marino", "dial_code": "+378", "code": "SM"},
        {"name": "Sao Tome and Principe", "label": "Sao Tome and Principe", "dial_code": "+239", "code": "ST"},
        {"name": "Saudi Arabia", "label": "Saudi Arabia", "dial_code": "+966", "code": "SA"},
        {"name": "Senegal", "label": "Senegal", "dial_code": "+221", "code": "SN"},
        {"name": "Serbia", "label": "Serbia", "dial_code": "+381", "code": "RS"},
        {"name": "Seychelles", "label": "Seychelles", "dial_code": "+248", "code": "SC"},
        {"name": "Sierra Leone", "label": "Sierra Leone", "dial_code": "+232", "code": "SL"},
        {"name": "Singapore", "label": "Singapore", "dial_code": "+65", "code": "SG"},
        {"name": "Slovakia", "label": "Slovakia", "dial_code": "+421", "code": "SK"},
        {"name": "Slovenia", "label": "Slovenia", "dial_code": "+386", "code": "SI"},
        {"name": "Solomon Islands", "label": "Solomon Islands", "dial_code": "+677", "code": "SB"},
        {"name": "Somalia", "label": "Somalia", "dial_code": "+252", "code": "SO"},
        {"name": "South Africa", "label": "South Africa", "dial_code": "+27", "code": "ZA"},
        {"name": "South Sudan", "label": "South Sudan", "dial_code": "+211", "code": "SS"},
        {
            "name": "South Georgia and the South Sandwich Islands",
            "label": "South Georgia and the South Sandwich Islands",
            "dial_code": "+500",
            "code": "GS"
        },
        {"name": "Spain", "label": "Spain", "dial_code": "+34", "code": "ES"},
        {"name": "Sri Lanka", "label": "Sri Lanka", "dial_code": "+94", "code": "LK"},
        {"name": "Sudan", "label": "Sudan", "dial_code": "+249", "code": "SD"},
        {"name": "Suriname", "label": "Suriname", "dial_code": "+597", "code": "SR"},
        {"name": "Svalbard and Jan Mayen", "label": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ"},
        {"name": "Swaziland", "label": "Swaziland", "dial_code": "+268", "code": "SZ"},
        {"name": "Sweden", "label": "Sweden", "dial_code": "+46", "code": "SE"},
        {"name": "Switzerland", "label": "Switzerland", "dial_code": "+41", "code": "CH"},
        {"name": "Syrian Arab Republic", "label": "Syrian Arab Republic", "dial_code": "+963", "code": "SY"},
        {"name": "Taiwan", "label": "Taiwan", "dial_code": "+886", "code": "TW"},
        {"name": "Tajikistan", "label": "Tajikistan", "dial_code": "+992", "code": "TJ"},
        {
            "name": "Tanzania, United Republic of Tanzania",
            "label": "Tanzania, United Republic of Tanzania",
            "dial_code": "+255",
            "code": "TZ"
        },
        {"name": "Thailand", "label": "Thailand", "dial_code": "+66", "code": "TH"},
        {"name": "Timor-Leste", "label": "Timor-Leste", "dial_code": "+670", "code": "TL"},
        {"name": "Togo", "label": "Togo", "dial_code": "+228", "code": "TG"},
        {"name": "Tokelau", "label": "Tokelau", "dial_code": "+690", "code": "TK"},
        {"name": "Tonga", "label": "Tonga", "dial_code": "+676", "code": "TO"},
        {"name": "Trinidad and Tobago", "label": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT"},
        {"name": "Tunisia", "label": "Tunisia", "dial_code": "+216", "code": "TN"},
        {"name": "Turkey", "label": "Turkey", "dial_code": "+90", "code": "TR"},
        {"name": "Turkmenistan", "label": "Turkmenistan", "dial_code": "+993", "code": "TM"},
        {"name": "Turks and Caicos Islands", "label": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC"},
        {"name": "Tuvalu", "label": "Tuvalu", "dial_code": "+688", "code": "TV"},
        {"name": "Uganda", "label": "Uganda", "dial_code": "+256", "code": "UG"},
        {"name": "Ukraine", "label": "Ukraine", "dial_code": "+380", "code": "UA"},
        {"name": "United Arab Emirates", "label": "United Arab Emirates", "dial_code": "+971", "code": "AE"},
        {"name": "United Kingdom", "label": "United Kingdom", "dial_code": "+44", "code": "GB"},
        {"name": "United States", "label": "United States", "dial_code": "+1", "code": "US"},
        {"name": "Uruguay", "label": "Uruguay", "dial_code": "+598", "code": "UY"},
        {"name": "Uzbekistan", "label": "Uzbekistan", "dial_code": "+998", "code": "UZ"},
        {"name": "Vanuatu", "label": "Vanuatu", "dial_code": "+678", "code": "VU"},
        {
            "name": "Venezuela, Bolivarian Republic of Venezuela",
            "label": "Venezuela, Bolivarian Republic of Venezuela",
            "dial_code": "+58",
            "code": "VE"
        },
        {"name": "Vietnam", "label": "Vietnam", "dial_code": "+84", "code": "VN"},
        {"name": "Virgin Islands, British", "label": "Virgin Islands, British", "dial_code": "+1284", "code": "VG"},
        {"name": "Virgin Islands, U.S.", "label": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI"},
        {"name": "Wallis and Futuna", "label": "Wallis and Futuna", "dial_code": "+681", "code": "WF"},
        {"name": "Yemen", "label": "Yemen", "dial_code": "+967", "code": "YE"},
        {"name": "Zambia", "label": "Zambia", "dial_code": "+260", "code": "ZM"},
        {"name": "Zimbabwe", "label": "Zimbabwe", "dial_code": "+263", "code": "ZW"}
    ],
    FULL_DAY_NAME : [
        {label: 'Sunday', value: 0, checked: false},
        {label: 'Monday', value: 1, checked: false},
        {label: 'Tuesday', value: 2, checked: false},
        {label: 'Wednesday', value: 3, checked: false},
        {label: 'Thursday', value: 4, checked: false},
        {label: 'Friday', value: 5, checked: false},
        {label: 'Saturday', value: 6, checked: false},
    ],
    DAY_NAME : [
        {label: 'Sun', value: 0, checked: false},
        {label: 'Mon', value: 1, checked: false},
        {label: 'Tue', value: 2, checked: false},
        {label: 'Wed', value: 3, checked: false},
        {label: 'Thu', value: 4, checked: false},
        {label: 'Fri', value: 5, checked: false},
        {label: 'Sat', value: 6, checked: false},
    ],
    REFERRAL_PAYOUT_TYPE: {1: 'On Candidate Joining', 2: 'Employee Status Change'},
    REFERRAL_FORMULA_TYPE: {1: 'Fixed Amount', 2: 'Formula Based'},
};

export const STAR_RATING = [
    {value: 5, label: '05'},
    {value: 10, label: '10'}
]


export const MOODICONS = [
    {label: `calm.png`, value: 'calm'},
    {label: `dull.png`, value: 'dull'},
    {label: `fantastic.png`, value: 'fantastic'},
    {label: `sad.png`, value: 'sad'},
    {label: `sick.png`, value: 'sick'},
    {label: `sleepy.png`, value: 'sleepy'},
];

export const MASTER_DATA_ACTION = {
    REPLACE: 0,
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
}

export const STRING_LIST = {
    COUNTRY: ['Afghanistan', 'land Islands', 'Albania', 'Algeria', 'American Samoa', 'AndorrA', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote D\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and Mcdonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'S Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People\'S Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory, Occupied', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'RWANDA', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S.', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
    COLOR: ['#60B158', '#007AFF', '#FFA700', '#FF6961', '#73788B', '#DC2ADE', '#2FB6CE', '#F25FA3', '#43D393', '#8C64FF', '#F4B377', '#757AFF', '#62B7E7', '#90D76F', '#ED93EF', '#7D5A5A', '#6886C5', '#F5B971', '#937D14', '#00BCD4', "#000000", "#0099ff", "#0E71C3", '#FF6961', '#73788B', '#DC2ADE']
}

export const EMP_STATUS = [
    {value: 'all', label: 'All Employees'},
    {value: 'active', label: 'Active Employees'},
    {value: 'inactive', label: 'Inactive Employees'},
];

export const EMP_GROUP_BY = [
    {value: 'location', label: 'Location'},
    {value: 'shift', label: 'Shift'},
    {value: 'department', label: 'Department'},
    {value: 'companyId', label: 'Sub Company'},
    {value: 'jobTitle', label: 'Job Title'}
];
export const UAC_CONSTANT = {
    HOLIDAY: "HOLIDAY",
    IPBLOCKING: "IPBLOCKING",
    OVERTIME: "OVERTIME",
    COMP_OFF: "COMPOFF",
    GEO: "GEO",
    PBD: "PBD",
    SHIFT: "SHIFT",
    PAYROLL_SALARY_TEMPLATE: "PAYROLL_SALARY_TEMPLATE",
    UAC: "UAC",
    WD: "WD",
    NWD: "NWD",
    LEAVE: "LEAVE",
    CLOCK_IN_SETTING: "CLOCK_IN_SETTING",
    POLICY_DOC: "POLICY_DOCUMENT",
    REFERRAL_POLICY: "REFERRAL_POLICY",
    SHIFT_SCHEDULER: "SHIFT_SCHEDULER",
    PRODUCT_ACCESS: "PRODUCT_ACCESS",
    REIMBURSEMENT: 'REIMBURSEMENT_TYPE',
    BIOMETRICS: "BIOMETRICS",
    CHAT_POLICY: "CHAT_POLICY",
    PLATFORM_POLICY: "LOGIN_RESTRICTION_POLICY",
}

export const UAC = {
    USER_TYPE: {
        EMPLOYEE: 1,
        MANAGER: 2,
        ADMIN: 3,
    },

    /**
     * Custom Project Permission Sections
     * **/
    taskAccess: 'taskAccess',
    projectMenu: 'projectMenu',
    projectSettings: 'projectSettings',

    /** ============================
     * Custom Project Permission >> taskAccess Modules
     * ==============================*/
    parentTask: 'parentTask',
    subTask: 'subTask',
    dueDate: 'dueDate',
    taskProgress: 'taskProgress',
    estimationHours : 'estimationHours',
    comments: 'comments',
    attachments: 'attachments',
    taskCompletion: 'taskCompletion',
    billingType: 'billingType',
    milestone: 'milestone',
    checkList: 'checkList',
    deleteOtherUserWorklog: 'deleteOtherUserWorklog',
    tag: 'tag',
    activity: 'activity',
    priority: 'priority',
    taskType: 'taskType',
    taskStatus: 'taskStatus',
    section: 'section',
    workLog: 'workLog', // editOthersWorkLog // deleteOthersWorkLog


    /**==============================
     * Custom Project Permission >> project Menu
     * =================================**/
    m_sectionOwner: "sectionOwner",
    m_milestone: "milestone",
    m_kanbanView: "kanbanView",
    m_ganttChart: "ganttChart",
    m_activities: "activities",
    m_documents: "documents",
    m_files: "files",
    m_mindMap: "mindMap",
    m_form: "form",
    m_timesheet: "timesheet",
    m_importTask: "importTask",
    m_billingReport: "billingReport",
    m_report: "report",
    m_mom: "mom",
    m_calendar: "calendar",
    m_workflow: "workflow",
    m_automation :  "automation",


    /**==============================
     * Custom Project Permission >> project Settings
     * =================================**/
    s_project : "projectDetails",
    s_activityList : "activityList",
    s_taskTypeList : "taskTypeList",
    s_taskStatusList : "taskStatusList",
    s_taskTagList : "taskTagList",
    s_projectCustomField : "projectCustomField",
    s_taskCustomField : "taskCustomField",
    s_integration : "integration",
    s_notification : "notificationSetting",
    s_teamLeader : "teamLeaderSettings",
    s_dependency : "dependencySettings",
    s_upworkReport : "upworkReportSettings",
    s_importProjectTemplate : "importProjectTemplate",
    s_cloneAsTemplate : "cloneAsTemplate",
    s_cloneAsProject : "cloneAsProject",
    s_archiveProject : "archiveProject",
    s_deleteProject : "deleteProject",


    /**==================================
     * client Side UAC >> Main menu
     * =================================**/
    c_product_menu : 'productMenu',
    c_project_menu : 'projectMenu',
}

export const LEAVE = {
    activity: [
        {value: 1, label: 'Created'},
        {value: 2, label: 'Modified'},
        {value: 3, label: 'Deleted'},
        {value: 5, label: 'Short Leave'},
    ],
    dayOptions: [
        {value: 1, label: 'Full Day'},
        {value: 2, label: '1st Half'},
        {value: 3, label: '2nd Half'},
        {value: 5, label: 'Short Leave'},
    ],
    dayStatus: [
        {label: 'HOLIDAY', value: 1},
        {label: 'WEEKEND', value: 2},
        {label: 'WORKING', value: 3},
        {label: 'FIRST_HALF_WORKING', value: 4},
        {label: 'SECOND_HALF_WORKING', value: 5},
        {label: 'FULL_DAY_LEAVE', value: 6},
        {label: 'FIRST_HALF_LEAVE', value: 7},
        {label: 'SECOND_HALF_LEAVE', value: 8},
    ]
}

export const COMPONENT_TYPE = {
    EARNING: 1,
    ADDITIONAL_EARNING: 2,
    DEDUCTION: 3,
    TDS: 4,
    REIMBURSEMENT: 5,
    ARREAR: 6,
    ADVANCE: 7,
    OVER_TIME: 8,
    LEAVE: 9,
    EMPLOYER_SHARE: 10,
    LEAVE_ENCASHMENT: 11,
    FORFEITED: 12,
    EXPENSE: 13,
    LOAN: 14,
    LEAVE_BALANCE: 15,
}

export const MONTH = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
    LIST: [
        {label: "January", value: 1, shortName: "Jan"},
        {label: "February", value: 2, shortName: "Feb"},
        {label: "March", value: 3, shortName: "Mar"},
        {label: "April", value: 4, shortName: "Apr"},
        {label: "May", value: 5, shortName: "May"},
        {label: "June", value: 6, shortName: "Jun"},
        {label: "July", value: 7, shortName: "Jul"},
        {label: "August", value: 8, shortName: "Aug"},
        {label: "September", value: 9, shortName: "Sep"},
        {label: "October", value: 10, shortName: "Oct"},
        {label: "November", value: 11, shortName: "Nov"},
        {label: "December", value: 12, shortName: "Dec"}
    ],
}

export const MONTHS_DAYS = [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
    {label: '9', value: 9},
    {label: '10', value: 10},
    {label: '11', value: 11},
    {label: '12', value: 12},
    {label: '13', value: 13},
    {label: '14', value: 14},
    {label: '15', value: 15},
    {label: '16', value: 16},
    {label: '17', value: 17},
    {label: '18', value: 18},
    {label: '19', value: 19},
    {label: '20', value: 20},
    {label: '21', value: 21},
    {label: '22', value: 22},
    {label: '23', value: 23},
    {label: '24', value: 24},
    {label: '25', value: 25},
    {label: '26', value: 26},
    {label: '27', value: 27},
    {label: '28', value: 28},
    {label: '29', value: 29},
    {label: '30', value: 30},
    {label: '31', value: 31},
];

export const TIMEZONE_OFFSET = {
    "Etc/GMT+12": 720,
    "Pacific/Niue": 660,
    "Pacific/Pago_Pago": 660,
    "America/Adak": 600,
    "Pacific/Honolulu": 600,
    "Pacific/Rarotonga": 600,
    "Pacific/Tahiti": 600,
    "Pacific/Marquesas": 570,
    "America/Anchorage": 540,
    "America/Juneau": 540,
    "America/Metlakatla": 540,
    "America/Nome": 540,
    "America/Sitka": 540,
    "America/Yakutat": 540,
    "Pacific/Gambier": 540,
    "America/Los_Angeles": 480,
    "America/Tijuana": 480,
    "America/Vancouver": 480,
    "Pacific/Pitcairn": 480,
    "America/Boise": 420,
    "America/Cambridge_Bay": 420,
    "America/Ciudad_Juarez": 420,
    "America/Dawson": 420,
    "America/Dawson_Creek": 420,
    "America/Denver": 420,
    "America/Edmonton": 420,
    "America/Fort_Nelson": 420,
    "America/Hermosillo": 420,
    "America/Inuvik": 420,
    "America/Mazatlan": 420,
    "America/Phoenix": 420,
    "America/Whitehorse": 420,
    "MST": 420,
    "America/Bahia_Banderas": 360,
    "America/Belize": 360,
    "America/Chicago": 360,
    "America/Chihuahua": 360,
    "America/Costa_Rica": 360,
    "America/El_Salvador": 360,
    "America/Guatemala": 360,
    "America/Indiana/Knox": 360,
    "America/Indiana/Tell_City": 360,
    "America/Managua": 360,
    "America/Matamoros": 360,
    "America/Menominee": 360,
    "America/Merida": 360,
    "America/Mexico_City": 360,
    "America/Monterrey": 360,
    "America/North_Dakota/Beulah": 360,
    "America/North_Dakota/Center": 360,
    "America/North_Dakota/New_Salem": 360,
    "America/Ojinaga": 360,
    "America/Rankin_Inlet": 360,
    "America/Regina": 360,
    "America/Resolute": 360,
    "America/Swift_Current": 360,
    "America/Tegucigalpa": 360,
    "America/Winnipeg": 360,
    "CST6CDT": 360,
    "Pacific/Galapagos": 360,
    "America/Bogota": 300,
    "America/Cancun": 300,
    "America/Detroit": 300,
    "America/Eirunepe": 300,
    "America/Grand_Turk": 300,
    "America/Guayaquil": 300,
    "America/Havana": 300,
    "America/Indiana/Indianapolis": 300,
    "America/Indiana/Marengo": 300,
    "America/Indiana/Petersburg": 300,
    "America/Indiana/Vevay": 300,
    "America/Indiana/Vincennes": 300,
    "America/Indiana/Winamac": 300,
    "America/Iqaluit": 300,
    "America/Jamaica": 300,
    "America/Kentucky/Louisville": 300,
    "America/Kentucky/Monticello": 300,
    "America/Lima": 300,
    "America/New_York": 300,
    "America/Panama": 300,
    "America/Port-au-Prince": 300,
    "America/Rio_Branco": 300,
    "America/Toronto": 300,
    "Pacific/Easter": 300,
    "America/Barbados": 240,
    "America/Boa_Vista": 240,
    "America/Campo_Grande": 240,
    "America/Caracas": 240,
    "America/Cuiaba": 240,
    "America/Glace_Bay": 240,
    "America/Goose_Bay": 240,
    "America/Guyana": 240,
    "America/Halifax": 240,
    "America/La_Paz": 240,
    "America/Manaus": 240,
    "America/Martinique": 240,
    "America/Moncton": 240,
    "America/Porto_Velho": 240,
    "America/Puerto_Rico": 240,
    "America/Santo_Domingo": 240,
    "America/Thule": 240,
    "Atlantic/Bermuda": 240,
    "America/St_Johns": 210,
    "America/Araguaina": 180,
    "America/Argentina/Buenos_Aires": 180,
    "America/Argentina/Catamarca": 180,
    "America/Argentina/Cordoba": 180,
    "America/Argentina/Jujuy": 180,
    "America/Argentina/La_Rioja": 180,
    "America/Argentina/Mendoza": 180,
    "America/Argentina/Rio_Gallegos": 180,
    "America/Argentina/Salta": 180,
    "America/Argentina/San_Juan": 180,
    "America/Argentina/San_Luis": 180,
    "America/Argentina/Tucuman": 180,
    "America/Argentina/Ushuaia": 180,
    "America/Asuncion": 180,
    "America/Bahia": 180,
    "America/Belem": 180,
    "America/Cayenne": 180,
    "America/Fortaleza": 180,
    "America/Maceio": 180,
    "America/Miquelon": 180,
    "America/Montevideo": 180,
    "America/Paramaribo": 180,
    "America/Punta_Arenas": 180,
    "America/Recife": 180,
    "America/Santarem": 180,
    "America/Santiago": 180,
    "America/Sao_Paulo": 180,
    "Antarctica/Palmer": 180,
    "Antarctica/Rothera": 180,
    "Atlantic/Stanley": 180,
    "America/Noronha": 120,
    "America/Nuuk": 120,
    "Atlantic/South_Georgia": 120,
    "America/Scoresbysund": 60,
    "Atlantic/Azores": 60,
    "Atlantic/Cape_Verde": 60,
    "Africa/Abidjan": 0,
    "Africa/Bissau": 0,
    "Africa/Monrovia": 0,
    "Africa/Sao_Tome": 0,
    "America/Danmarkshavn": 0,
    "Antarctica/Troll": 0,
    "Atlantic/Canary": 0,
    "Atlantic/Faroe": 0,
    "Atlantic/Madeira": 0,
    "Europe/Dublin": 0,
    "Europe/Lisbon": 0,
    "Europe/London": 0,
    "GMT": 0,
    "Africa/Algiers": -60,
    "Africa/Casablanca": -60,
    "Africa/Ceuta": -60,
    "Africa/El_Aaiun": -60,
    "Africa/Lagos": -60,
    "Africa/Ndjamena": -60,
    "Africa/Tunis": -60,
    "Europe/Andorra": -60,
    "Europe/Belgrade": -60,
    "Europe/Berlin": -60,
    "Europe/Brussels": -60,
    "Europe/Budapest": -60,
    "Europe/Gibraltar": -60,
    "Europe/Madrid": -60,
    "Europe/Malta": -60,
    "Europe/Paris": -60,
    "Europe/Prague": -60,
    "Europe/Rome": -60,
    "Europe/Tirane": -60,
    "Europe/Vienna": -60,
    "Europe/Warsaw": -60,
    "Europe/Zurich": -60,
    "MET": -60,
    "Africa/Cairo": -120,
    "Africa/Johannesburg": -120,
    "Africa/Juba": -120,
    "Africa/Khartoum": -120,
    "Africa/Maputo": -120,
    "Africa/Tripoli": -120,
    "Africa/Windhoek": -120,
    "Asia/Beirut": -120,
    "Asia/Famagusta": -120,
    "Asia/Gaza": -120,
    "Asia/Hebron": -120,
    "Asia/Jerusalem": -120,
    "Asia/Nicosia": -120,
    "EET": -120,
    "Europe/Athens": -120,
    "Europe/Bucharest": -120,
    "Europe/Chisinau": -120,
    "Europe/Helsinki": -120,
    "Europe/Kaliningrad": -120,
    "Europe/Kyiv": -120,
    "Europe/Riga": -120,
    "Europe/Sofia": -120,
    "Europe/Tallinn": -120,
    "Europe/Vilnius": -120,
    "Africa/Nairobi": -180,
    "Asia/Amman": -180,
    "Asia/Baghdad": -180,
    "Asia/Damascus": -180,
    "Asia/Qatar": -180,
    "Asia/Riyadh": -180,
    "Europe/Istanbul": -180,
    "Europe/Kirov": -180,
    "Europe/Minsk": -180,
    "Europe/Moscow": -180,
    "Europe/Simferopol": -180,
    "Europe/Volgograd": -180,
    "Asia/Tehran": -210,
    "Asia/Baku": -240,
    "Asia/Dubai": -240,
    "Asia/Tbilisi": -240,
    "Asia/Yerevan": -240,
    "Europe/Astrakhan": -240,
    "Europe/Samara": -240,
    "Europe/Saratov": -240,
    "Europe/Ulyanovsk": -240,
    "Indian/Mauritius": -240,
    "Asia/Kabul": -270,
    "Antarctica/Mawson": -300,
    "Asia/Aqtau": -300,
    "Asia/Aqtobe": -300,
    "Asia/Ashgabat": -300,
    "Asia/Atyrau": -300,
    "Asia/Dushanbe": -300,
    "Asia/Karachi": -300,
    "Asia/Oral": -300,
    "Asia/Qyzylorda": -300,
    "Asia/Samarkand": -300,
    "Asia/Tashkent": -300,
    "Asia/Yekaterinburg": -300,
    "Indian/Maldives": -300,
    "Asia/Colombo": -330,
    "Asia/Kolkata": -330,
    "Asia/Kathmandu": -345,
    "Asia/Almaty": -360,
    "Asia/Bishkek": -360,
    "Asia/Dhaka": -360,
    "Asia/Omsk": -360,
    "Asia/Qostanay": -360,
    "Asia/Thimphu": -360,
    "Asia/Urumqi": -360,
    "Indian/Chagos": -360,
    "Asia/Yangon": -390,
    "Antarctica/Davis": -420,
    "Asia/Bangkok": -420,
    "Asia/Barnaul": -420,
    "Asia/Ho_Chi_Minh": -420,
    "Asia/Hovd": -420,
    "Asia/Jakarta": -420,
    "Asia/Krasnoyarsk": -420,
    "Asia/Novokuznetsk": -420,
    "Asia/Novosibirsk": -420,
    "Asia/Pontianak": -420,
    "Asia/Tomsk": -420,
    "Asia/Choibalsan": -480,
    "Asia/Hong_Kong": -480,
    "Asia/Irkutsk": -480,
    "Asia/Kuching": -480,
    "Asia/Macau": -480,
    "Asia/Makassar": -480,
    "Asia/Manila": -480,
    "Asia/Shanghai": -480,
    "Asia/Singapore": -480,
    "Asia/Taipei": -480,
    "Asia/Ulaanbaatar": -480,
    "Australia/Perth": -480,
    "Australia/Eucla": -525,
    "Asia/Chita": -540,
    "Asia/Dili": -540,
    "Asia/Jayapura": -540,
    "Asia/Khandyga": -540,
    "Asia/Pyongyang": -540,
    "Asia/Seoul": -540,
    "Asia/Tokyo": -540,
    "Asia/Yakutsk": -540,
    "Pacific/Palau": -540,
    "Australia/Darwin": -570,
    "Asia/Ust-Nera": -600,
    "Asia/Vladivostok": -600,
    "Australia/Brisbane": -600,
    "Australia/Lindeman": -600,
    "Pacific/Guam": -600,
    "Pacific/Port_Moresby": -600,
    "Australia/Adelaide": -630,
    "Australia/Broken_Hill": -630,
    "Antarctica/Casey": -660,
    "Antarctica/Macquarie": -660,
    "Asia/Magadan": -660,
    "Asia/Sakhalin": -660,
    "Asia/Srednekolymsk": -660,
    "Australia/Hobart": -660,
    "Australia/Lord_Howe": -660,
    "Australia/Melbourne": -660,
    "Australia/Sydney": -660,
    "Pacific/Bougainville": -660,
    "Pacific/Efate": -660,
    "Pacific/Guadalcanal": -660,
    "Pacific/Kosrae": -660,
    "Pacific/Noumea": -660,
    "Asia/Anadyr": -720,
    "Asia/Kamchatka": -720,
    "Pacific/Fiji": -720,
    "Pacific/Kwajalein": -720,
    "Pacific/Nauru": -720,
    "Pacific/Norfolk": -720,
    "Pacific/Tarawa": -720,
    "Pacific/Apia": -780,
    "Pacific/Auckland": -780,
    "Pacific/Fakaofo": -780,
    "Pacific/Kanton": -780,
    "Pacific/Tongatapu": -780,
    "Pacific/Chatham": -825,
    "Pacific/Kiritimati": -840
}

export const CURRENCY_LOCALE = {
    "AED": { symbol: "د.إ", language: "ar-AE", name: "UAE Dirham", secondaryLanguage: "en-AE"},
    "AFN": { symbol: "؋", language: "fa-AF", name: "Afghan Afghani", secondaryLanguage: "en-AF"},
    "ALL": { symbol: "L", language: "sq-AL", name: "Albanian Lek", secondaryLanguage: "en-AL"},
    "AMD": { symbol: "֏", language: "hy-AM", name: "Armenian Dram", secondaryLanguage: "en-AM"},
    "ANG": { symbol: "ƒ", language: "nl-AN", name: "Netherlands Antillean Guilder", secondaryLanguage: "en-AN"},
    "AOA": { symbol: "Kz", language: "pt-AO", name: "Angolan Kwanza", secondaryLanguage: "en-AO"},
    "ARS": { symbol: "$", language: "es-AR", name: "Argentine Peso", secondaryLanguage: "en-AR"},
    "AUD": { symbol: "$", language: "en-AU", name: "Australian Dollar", secondaryLanguage: "en-AU"},
    "AWG": { symbol: "ƒ", language: "nl-AW", name: "Aruban Florin", secondaryLanguage: "en-AW"},
    "AZN": { symbol: "₼", language: "az-AZ", name: "Azerbaijani Manat", secondaryLanguage: "en-AZ"},
    "BAM": { symbol: "KM", language: "bs-BA", name: "Bosnian Convertible Mark", secondaryLanguage: "en-BA"},
    "BBD": { symbol: "$", language: "en-BB", name: "Barbadian Dollar", secondaryLanguage: "en-BB"},
    "BDT": { symbol: "৳", language: "bn-BD", name: "Bangladeshi Taka", secondaryLanguage: "en-BD"},
    "BGN": { symbol: "лв", language: "bg-BG", name: "Bulgarian Lev", secondaryLanguage: "en-BG"},
    "BHD": { symbol: ".د.ب", language: "ar-BH", name: "Bahraini Dinar", secondaryLanguage: "en-BH"},
    "BIF": { symbol: "FBu", language: "fr-BI", name: "Burundian Franc", secondaryLanguage: "en-BI"},
    "BMD": { symbol: "$", language: "en-BM", name: "Bermudian Dollar", secondaryLanguage: "en-BM"},
    "BND": { symbol: "$", language: "ms-BN", name: "Brunei Dollar", secondaryLanguage: "en-BN"},
    "BOB": { symbol: "Bs.", language: "es-BO", name: "Bolivian Boliviano", secondaryLanguage: "en-BO"},
    "BRL": { symbol: "R$", language: "pt-BR", name: "Brazilian Real", secondaryLanguage: "en-BR"},
    "BSD": { symbol: "$", language: "en-BS", name: "Bahamian Dollar", secondaryLanguage: "en-BS"},
    "BTN": { symbol: "Nu.", language: "dz-BT", name: "Bhutanese Ngultrum", secondaryLanguage: "en-BT"},
    "BWP": { symbol: "P", language: "en-BW", name: "Botswanan Pula", secondaryLanguage: "en-BW"},
    "BYN": { symbol: "Br", language: "be-BY", name: "Belarusian Ruble", secondaryLanguage: "en-BY"},
    "BZD": { symbol: "$", language: "en-BZ", name: "Belize Dollar", secondaryLanguage: "en-BZ"},
    "CAD": { symbol: "$", language: "en-CA", name: "Canadian Dollar", secondaryLanguage: "en-CA"},
    "CDF": { symbol: "FC", language: "fr-CD", name: "Congolese Franc", secondaryLanguage: "en-CD"},
    "CHF": { symbol: "CHF", language: "de-CH", name: "Swiss Franc", secondaryLanguage: "en-CH"},
    "CLP": { symbol: "$", language: "es-CL", name: "Chilean Peso", secondaryLanguage: "en-CL"},
    "CNY": { symbol: "¥", language: "zh-CN", name: "Chinese Yuan", secondaryLanguage: "en-CN"},
    "COP": { symbol: "$", language: "es-CO", name: "Colombian Peso", secondaryLanguage: "en-CO"},
    "CRC": { symbol: "₡", language: "es-CR", name: "Costa Rican Colón", secondaryLanguage: "en-CR"},
    "CUC": { symbol: "$", language: "es-CU", name: "Cuban Convertible Peso", secondaryLanguage: "en-CU"},
    "CUP": { symbol: "$", language: "es-CU", name: "Cuban Peso", secondaryLanguage: "en-CU"},
    "CVE": { symbol: "$", language: "pt-CV", name: "Cape Verdean Escudo", secondaryLanguage: "en-CV"},
    "CZK": { symbol: "Kč", language: "cs-CZ", name: "Czech Koruna", secondaryLanguage: "en-CZ"},
    "DJF": { symbol: "Fdj", language: "fr-DJ", name: "Djiboutian Franc", secondaryLanguage: "en-DJ"},
    "DKK": { symbol: "kr", language: "da-DK", name: "Danish Krone", secondaryLanguage: "en-DK"},
    "DOP": { symbol: "$", language: "es-DO", name: "Dominican Peso", secondaryLanguage: "en-DO"},
    "DZD": { symbol: "د.ج", language: "ar-DZ", name: "Algerian Dinar", secondaryLanguage: "en-DZ"},
    "EGP": { symbol: "£", language: "ar-EG", name: "Egyptian Pound", secondaryLanguage: "en-EG"},
    "ERN": { symbol: "Nfk", language: "ti-ER", name: "Eritrean Nakfa", secondaryLanguage: "en-ER"},
    "ETB": { symbol: "Br", language: "am-ET", name: "Ethiopian Birr", secondaryLanguage: "en-ET"},
    "EUR": { symbol: "€", language: "de-DE", name: "Euro", secondaryLanguage: "en-DE"},
    "FJD": { symbol: "$", language: "en-FJ", name: "Fijian Dollar", secondaryLanguage: "en-FJ"},
    "FKP": { symbol: "£", language: "en-FK", name: "Falkland Islands Pound", secondaryLanguage: "en-FK"},
    "FOK": { symbol: "kr", language: "fo-FO", name: "Faroese Króna", secondaryLanguage: "en-FO"},
    "GBP": { symbol: "£", language: "en-GB", name: "British Pound", secondaryLanguage: "en-GB"},
    "GEL": { symbol: "₾", language: "ka-GE", name: "Georgian Lari", secondaryLanguage: "en-GE"},
    "GGP": { symbol: "£", language: "en-GG", name: "Guernsey Pound", secondaryLanguage: "en-GG"},
    "GHS": { symbol: "₵", language: "en-GH", name: "Ghanaian Cedi", secondaryLanguage: "en-GH"},
    "GIP": { symbol: "£", language: "en-GI", name: "Gibraltar Pound", secondaryLanguage: "en-GI"},
    "GMD": { symbol: "D", language: "en-GM", name: "Gambian Dalasi", secondaryLanguage: "en-GM"},
    "GNF": { symbol: "FG", language: "fr-GN", name: "Guinean Franc", secondaryLanguage: "en-GN"},
    "GTQ": { symbol: "Q", language: "es-GT", name: "Guatemalan Quetzal", secondaryLanguage: "en-GT"},
    "GYD": { symbol: "$", language: "en-GY", name: "Guyanaese Dollar", secondaryLanguage: "en-GY"},
    "HKD": { symbol: "$", language: "en-HK", name: "Hong Kong Dollar", secondaryLanguage: "en-HK"},
    "HNL": { symbol: "L", language: "es-HN", name: "Honduran Lempira", secondaryLanguage: "en-HN"},
    "HRK": { symbol: "kn", language: "hr-HR", name: "Croatian Kuna", secondaryLanguage: "en-HR"},
    "HTG": { symbol: "G", language: "fr-HT", name: "Haitian Gourde", secondaryLanguage: "en-HT"},
    "HUF": { symbol: "Ft", language: "hu-HU", name: "Hungarian Forint", secondaryLanguage: "en-HU"},
    "IDR": { symbol: "Rp", language: "id-ID", name: "Indonesian Rupiah", secondaryLanguage: "en-ID"},
    "ILS": { symbol: "₪", language: "he-IL", name: "Israeli Shekel", secondaryLanguage: "en-IL"},
    "IMP": { symbol: "£", language: "en-IM", name: "Isle of Man Pound", secondaryLanguage: "en-IM"},
    "INR": { symbol: "₹", language: "hi-IN", name: "Indian Rupee", secondaryLanguage: "en-IN"},
    "IQD": { symbol: "ع.د", language: "ar-IQ", name: "Iraqi Dinar", secondaryLanguage: "en-IQ"},
    "IRR": { symbol: "﷼", language: "fa-IR", name: "Iranian Rial", secondaryLanguage: "en-IR"},
    "ISK": { symbol: "kr", language: "is-IS", name: "Icelandic Króna", secondaryLanguage: "en-IS"},
    "JEP": { symbol: "£", language: "en-JE", name: "Jersey Pound", secondaryLanguage: "en-JE"},
    "JMD": { symbol: "$", language: "en-JM", name: "Jamaican Dollar", secondaryLanguage: "en-JM"},
    "JOD": { symbol: "د.ا", language: "ar-JO", name: "Jordanian Dinar", secondaryLanguage: "en-JO"},
    "JPY": { symbol: "¥", language: "ja-JP", name: "Japanese Yen", secondaryLanguage: "en-JP"},
    "KES": { symbol: "Sh", language: "en-KE", name: "Kenyan Shilling", secondaryLanguage: "en-KE"},
    "KGS": { symbol: "лв", language: "ky-KG", name: "Kyrgystani Som", secondaryLanguage: "en-KG"},
    "KHR": { symbol: "៛", language: "km-KH", name: "Cambodian Riel", secondaryLanguage: "en-KH"},
    "KID": { symbol: "$", language: "en-KI", name: "Kiribati Dollar", secondaryLanguage: "en-KI"},
    "KMF": { symbol: "CF", language: "fr-KM", name: "Comorian Franc", secondaryLanguage: "en-KM"},
    "KRW": { symbol: "₩", language: "ko-KR", name: "South Korean Won", secondaryLanguage: "en-KR"},
    "KPW": { symbol: "₩", language: "ko-KP", name: "North Korean Won", secondaryLanguage: "en-KP"},
    "KWD": { symbol: "د.ك", language: "ar-KW", name: "Kuwaiti Dinar", secondaryLanguage: "en-KW"},
    "KYD": { symbol: "$", language: "en-KY", name: "Cayman Islands Dollar", secondaryLanguage: "en-KY"},
    "KZT": { symbol: "〒", language: "kk-KZ", name: "Kazakhstani Tenge", secondaryLanguage: "en-KZ"},
    "LAK": { symbol: "₭", language: "lo-LA", name: "Laotian Kip", secondaryLanguage: "en-LA"},
    "LBP": { symbol: "ل.ل", language: "ar-LB", name: "Lebanese Pound", secondaryLanguage: "en-LB"},
    "LKR": { symbol: "Rs", language: "si-LK", name: "Sri Lankan Rupee", secondaryLanguage: "en-LK"},
    "LRD": { symbol: "$", language: "en-LR", name: "Liberian Dollar", secondaryLanguage: "en-LR"},
    "LSL": { symbol: "L", language: "en-LS", name: "Lesotho Loti", secondaryLanguage: "en-LS"},
    "LYD": { symbol: "د.ل", language: "ar-LY", name: "Libyan Dinar", secondaryLanguage: "en-LY"},
    "MAD": { symbol: "د.م.", language: "ar-MA", name: "Moroccan Dirham", secondaryLanguage: "en-MA"},
    "MDL": { symbol: "lei", language: "ro-MD", name: "Moldovan Leu", secondaryLanguage: "en-MD"},
    "MGA": { symbol: "Ar", language: "mg-MG", name: "Malagasy Ariary", secondaryLanguage: "en-MG"},
    "MKD": { symbol: "ден", language: "mk-MK", name: "Macedonian Denar", secondaryLanguage: "en-MK"},
    "MMK": { symbol: "Ks", language: "my-MM", name: "Burmese Kyat", secondaryLanguage: "en-MM"},
    "MNT": { symbol: "₮", language: "mn-MN", name: "Mongolian Tugrik", secondaryLanguage: "en-MN"},
    "MOP": { symbol: "MOP$", language: "zh-MO", name: "Macanese Pataca", secondaryLanguage: "en-MO"},
    "MRO": { symbol: "UM", language: "ar-MR", name: "Mauritanian Ouguiya", secondaryLanguage: "en-MR"},
    "MRU": { symbol: "UM", language: "ar-MR", name: "Mauritanian Ouguiya", secondaryLanguage: "en-MR"},
    "MUR": { symbol: "₨", language: "en-MU", name: "Mauritian Rupee", secondaryLanguage: "en-MU"},
    "MVR": { symbol: "Rf", language: "dv-MV", name: "Maldivian Rufiyaa", secondaryLanguage: "en-MV"},
    "MWK": { symbol: "MK", language: "ny-MW", name: "Malawian Kwacha", secondaryLanguage: "en-MW"},
    "MXN": { symbol: "$", language: "es-MX", name: "Mexican Peso", secondaryLanguage: "en-MX"},
    "MYR": { symbol: "RM", language: "ms-MY", name: "Malaysian Ringgit", secondaryLanguage: "en-MY"},
    "MZN": { symbol: "MT", language: "pt-MZ", name: "Mozambican Metical", secondaryLanguage: "en-MZ"},
    "NAD": { symbol: "$", language: "en-NA", name: "Namibian Dollar", secondaryLanguage: "en-NA"},
    "NGN": { symbol: "₦", language: "en-NG", name: "Nigerian Naira", secondaryLanguage: "en-NG"},
    "NIO": { symbol: "C$", language: "es-NI", name: "Nicaraguan Córdoba", secondaryLanguage: "en-NI"},
    "NOK": { symbol: "kr", language: "no-NO", name: "Norwegian Krone", secondaryLanguage: "en-NO"},
    "NPR": { symbol: "Rs", language: "ne-NP", name: "Nepalese Rupee", secondaryLanguage: "en-NP"},
    "NZD": { symbol: "$", language: "en-NZ", name: "New Zealand Dollar", secondaryLanguage: "en-NZ"},
    "OMR": { symbol: "ر.ع.", language: "ar-OM", name: "Omani Rial", secondaryLanguage: "en-OM"},
    "PAB": { symbol: "B/.", language: "es-PA", name: "Panamanian Balboa", secondaryLanguage: "en-PA"},
    "PEN": { symbol: "S/", language: "es-PE", name: "Peruvian Nuevo Sol", secondaryLanguage: "en-PE"},
    "PGK": { symbol: "K", language: "en-PG", name: "Papua New Guinean Kina", secondaryLanguage: "en-PG"},
    "PHP": { symbol: "₱", language: "fil-PH", name: "Philippine Peso", secondaryLanguage: "en-PH"},
    "PKR": { symbol: "Rs", language: "ur-PK", name: "Pakistani Rupee", secondaryLanguage: "en-PK"},
    "PLN": { symbol: "zł", language: "pl-PL", name: "Polish Zloty", secondaryLanguage: "en-PL"},
    "PYG": { symbol: "₲", language: "es-PY", name: "Paraguayan Guarani", secondaryLanguage: "en-PY"},
    "QAR": { symbol: "ر.ق", language: "ar-QA", name: "Qatari Rial", secondaryLanguage: "en-QA"},
    "RON": { symbol: "lei", language: "ro-RO", name: "Romanian Leu", secondaryLanguage: "en-RO"},
    "RSD": { symbol: "дин", language: "sr-RS", name: "Serbian Dinar", secondaryLanguage: "en-RS"},
    "RUB": { symbol: "₽", language: "ru-RU", name: "Russian Ruble", secondaryLanguage: "en-RU"},
    "RWF": { symbol: "FRw", language: "rw-RW", name: "Rwandan Franc", secondaryLanguage: "en-RW"},
    "SAR": { symbol: "ر.س", language: "ar-SA", name: "Saudi Riyal", secondaryLanguage: "en-SA"},
    "SBD": { symbol: "$", language: "en-SB", name: "Solomon Islands Dollar", secondaryLanguage: "en-SB"},
    "SCR": { symbol: "₨", language: "fr-SC", name: "Seychellois Rupee", secondaryLanguage: "en-SC"},
    "SDG": { symbol: "ج.س.", language: "ar-SD", name: "Sudanese Pound", secondaryLanguage: "en-SD"},
    "SEK": { symbol: "kr", language: "sv-SE", name: "Swedish Krona", secondaryLanguage: "en-SE"},
    "SGD": { symbol: "$", language: "en-SG", name: "Singapore Dollar", secondaryLanguage: "en-SG"},
    "SHP": { symbol: "£", language: "en-SH", name: "Saint Helena Pound", secondaryLanguage: "en-SH"},
    "SLL": { symbol: "Le", language: "en-SL", name: "Sierra Leonean Leone", secondaryLanguage: "en-SL"},
    "SOS": { symbol: "Sh", language: "so-SO", name: "Somali Shilling", secondaryLanguage: "en-SO"},
    "SRD": { symbol: "$", language: "nl-SR", name: "Surinamese Dollar", secondaryLanguage: "en-SR"},
    "SSP": { symbol: "£", language: "en-SS", name: "South Sudanese Pound", secondaryLanguage: "en-SS"},
    "STN": { symbol: "Db", language: "pt-ST", name: "São Tomé and Príncipe Dobra", secondaryLanguage: "en-ST"},
    "STD": { symbol: "Db", language: "pt-ST", name: "São Tomé and Príncipe Dobra", secondaryLanguage: "en-ST"},
    "SYP": { symbol: "ل.س", language: "ar-SY", name: "Syrian Pound", secondaryLanguage: "en-SY"},
    "SZL": { symbol: "E", language: "en-SZ", name: "Swazi Lilangeni", secondaryLanguage: "en-SZ"},
    "THB": { symbol: "฿", language: "th-TH", name: "Thai Baht", secondaryLanguage: "en-TH"},
    "TJS": { symbol: "SM", language: "tg-TJ", name: "Tajikistani Somoni", secondaryLanguage: "en-TJ"},
    "TMT": { symbol: "T", language: "tk-TM", name: "Turkmenistani Manat", secondaryLanguage: "en-TM"},
    "TND": { symbol: "د.ت", language: "ar-TN", name: "Tunisian Dinar", secondaryLanguage: "en-TN"},
    "TOP": { symbol: "T$", language: "en-TO", name: "Tongan Paʻanga", secondaryLanguage: "en-TO"},
    "TRY": { symbol: "₺", language: "tr-TR", name: "Turkish Lira", secondaryLanguage: "en-TR"},
    "TTD": { symbol: "$", language: "en-TT", name: "Trinidad and Tobago Dollar", secondaryLanguage: "en-TT"},
    "TVD": { symbol: "$", language: "en-TV", name: "Tuvaluan Dollar", secondaryLanguage: "en-TV"},
    "TWD": { symbol: "NT$", language: "zh-TW", name: "New Taiwan Dollar", secondaryLanguage: "en-TW"},
    "TZS": { symbol: "TSh", language: "sw-TZ", name: "Tanzanian Shilling", secondaryLanguage: "en-TZ"},
    "UAH": { symbol: "₴", language: "uk-UA", name: "Ukrainian Hryvnia", secondaryLanguage: "en-UA"},
    "UGX": { symbol: "USh", language: "en-UG", name: "Ugandan Shilling", secondaryLanguage: "en-UG"},
    "USD": { symbol: "$", language: "en-US", name: "United States Dollar", secondaryLanguage: "en-US"},
    "UYU": { symbol: "$", language: "es-UY", name: "Uruguayan Peso", secondaryLanguage: "en-UY"},
    "UZS": { symbol: "лв", language: "uz-UZ", name: "Uzbekistani Som", secondaryLanguage: "en-UZ"},
    "VES": { symbol: "Bs.S.", language: "es-VE", name: "Venezuelan Sovereign Bolívar", secondaryLanguage: "en-VE"},
    "VND": { symbol: "₫", language: "vi-VN", name: "Vietnamese Dong", secondaryLanguage: "en-VN"},
    "VUV": { symbol: "VT", language: "bi-VU", name: "Vanuatu Vatu", secondaryLanguage: "en-VU"},
    "WST": { symbol: "T", language: "sm-WS", name: "Samoan Tala", secondaryLanguage: "en-WS"},
    "XAF": { symbol: "FCFA", language: "fr-CM", name: "CFA Franc BEAC", secondaryLanguage: "en-CM"},
    "XAG": { symbol: "XAG", language: "", name: "Silver Ounce", secondaryLanguage: "en"},
    "XAU": { symbol: "XAU", language: "", name: "Gold Ounce", secondaryLanguage: "en"},
    "XCD": { symbol: "$", language: "en-CB", name: "East Caribbean Dollar", secondaryLanguage: "en-CB"},
    "XDR": { symbol: "XDR", language: "", name: "Special Drawing Rights", secondaryLanguage: "en"},
    "XOF": { symbol: "CFA", language: "fr-BJ", name: "CFA Franc BCEAO", secondaryLanguage: "en-BJ"},
    "XPF": { symbol: "CFPF", language: "fr-PF", name: "CFP Franc", secondaryLanguage: "en-PF"},
    "YER": { symbol: "ر.ي", language: "ar-YE", name: "Yemeni Rial", secondaryLanguage: "en-YE"},
    "ZAR": { symbol: "R", language: "en-ZA", name: "South African Rand", secondaryLanguage: "en-ZA"},
    "ZMW": { symbol: "ZK", language: "en-ZM", name: "Zambian Kwacha", secondaryLanguage: "en-ZM"},
    "ZWL": { symbol: "$", language: "en-ZW", name: "Zimbabwean Dollar",secondaryLanguage: "en-ZW" }
}

export const PLAN = {
    attachmentSize: "attachmentSize",
    storage: "storage",
    employee: "emp",
    employee360: "employee360",
    attendance: "attendance",
    attendanceOnDutyWFH: "attendanceOnDutyWFH",
    attendanceMonthlyAttendance: "attendanceMonthlyAttendance",
    attendanceVerification: "attendanceVerification",
    attendanceAbsentPresent: "attendanceAbsentPresent",
    attendancePresentbyDefault: "attendancePresentbyDefault",
    attendanceNonWorkingDay: "attendanceNonWorkingDay",
    attendanceWorkingDay: "attendanceWorkingDay",
    attendanceShiftCalendar: "attendanceShiftCalendar",
    overtime: "overtime",
    holiday: "holiday",
    leave: "leave",
    leaveCompOff: "leaveCompOff",
    documents: "documents",
    aadhaarCardVerification: 'aadhaarCardVerification',
    panCardVerification: 'panCardVerification',
    aadhaarPanLinkStatus: 'aadhaarPanLinkStatus',
    documentScan: "documentScan",
    performance: "performance",
    social: "social",
    helpDesk: "helpDesk",
    onboarding: "onboarding",
    reimbursement: "reimbursement",
    shiftSchedular: "shiftSchedular",
    faceScan: "faceScan",
    biometricsIntegration: "biometricsIntegration",
    geoFencing: "geoFencing",
    geoTagging: "geoTagging",
    settingsSubcompany: "settingsSubcompany",
    settingsLocations: "settingsLocations",
    attendancePenaltyReprocess: "attendancePenaltyReprocess",
    attendanceShiftRequest: "attendanceShiftRequest",
    budget: "budget",
    customField: "customField",
    expense: "expense",
    ipRestriction: "ipRestriction",
    multiplatformLoginRestriction: "multiplatformLoginRestriction",
    productivity: "productivity",
    queryBuilder: "queryBuilder",
    recaptcha: "recaptcha",
    routeMap: "routeMap",
    multiFactorAuthentication: "multiFactorAuthentication",
    runPayroll: "runPayroll",
    importPayroll: "importPayroll",
    splitPayment: "splitPayment",
    earningDeduction: "earningDeduction",
    targetAchievement: "targetAchievement",
    tdsDeclaration: "tdsDeclaration",
    tdsEarningExemptionBenefit: "tdsEarningExemptionBenefit",
    tdsOverride: "tdsOverride",
    previousEmploymentTds: "previousEmploymentTds",
    taxRegimeReport: "taxRegimeReport",
    advance: "advance",
    arrears: "arrears",
    loan: "loan",
    challan: "challan",
    form16: "form16",
    form12bb: "form12bb",
    form23: "form23",
    form24q: "form24q",
    payrollAnalytics: "payrollAnalytics",
    compareCompensationCost: "compareCompensationCost",
    locationBasedAttendance: "locationBasedAttendance",
    additionalComponentPolicy: "additionalComponentPolicy",
    componentRules: "componentRules",
    lwf: "lwf",
    securityDeposit: "securityDeposit",
    gratuitySetting: "gratuitySetting",
    newJoiningReferralBonus: "newJoiningReferralBonus",
    objective: "objective",
    evaluation: "evaluation",
    project: "project",
    projectGanttChart: "projectGanttChart",
    projectMilestones: "projectMilestones",
    projectFiles: "projectFiles",
    projectImportTasks: "projectImportTasks",
    projectMom: "projectMom",
    projectCustomFields: "projectCustomFields",
    tasksCustomFields: "tasksCustomFields",
    projectTemplates: "projectTemplates",
    dependency: "dependency",
    resourceResource: "resourceResource",
    clientList: "clientList",
    upworksIntegration: "upworksIntegration",
    projectDocument: "projectDocument",
    integration: "integration",
    projectForm: "projectForm",
    projectMindMap: "projectMindMap",
    resourcePlanner: "resourcePlanner",
    workDiary: "workDiary",
    jobs: "jobs",
    candidates: "candidates",
    reminder: "reminder",
    interview: "interview",
    requisitions: "requisitions",
    referrals: "referrals",
    zoomIntegration: "zoomIntegration",
    googleMeetIntegration: "googleMeetIntegration",
    teamsIntegration: "teamsIntegration",
    slackIntegration: "slackIntegration",
    publicPortal: "publicPortal",
    preBoarding: "preBoarding",
    contractor: 'contractor',
    orgStructure: 'orgStructure',
    whatsappIntegration: 'whatsappIntegration',
    whatsAppBot: 'whatsAppBot',

    // super track
    keyboardMouse: "keyboardMouse",
    application: "application",
    website: "website",
    liveMonitoring: "liveMonitoring",
    deviceTracking: "deviceTracking",
    behaviorAlerts: "behaviorAlerts",
    activityRiskDetect: "activityRiskDetect",
}

/*************************************************************
 * src/constant
 ************************************************************ */
export const LENGTH = {
    TAGS: 30,
    SEARCH: 2
}
export const TIMEOUT = {
    TOAST: 5000,
    DE_BOUNCING: 500,
}
export const DELAY = {
    TOOLTIP: 500,
}
export const LIST = {
    HOLIDAY_ICON: [
        { label: <Icon.Kite size={20} fill="#73788B" />, value: 'kite' },
        { label: <Icon.Holi size={20} fill="#73788B" />, value: 'holi' },
        { label: <Icon.Diwali size={20} fill="#73788B" />, value: 'diwali' },
        { label: <Icon.Christmas size={20} fill="#73788B" />, value: 'christmas' },
        { label: <Icon.SportsDay size={20} fill="#73788B" />, value: 'sportsDay' },
        { label: <Icon.RakshaBandhan size={20} fill="#73788B" />, value: 'rakshaBandhan' },
        { label: <Icon.Janmashtami size={20} fill="#73788B" />, value: 'janmashtami' },
        { label: <Icon.Ganesh size={20} fill="#73788B" />, value: 'ganesh' },
        { label: <Icon.Dussehra size={20} fill="#73788B" />, value: 'dussehra' },
        { label: <Icon.Navratri size={20} fill="#73788B" />, value: 'navratri' },
        { label: <Icon.Independence size={20} fill="#73788B" />, value: 'independence' },
        { label: <Icon.Republic size={20} fill="#73788B" />, value: 'republic' },
        // Keep in sync with hrms/src/common/constant.jsx ICONS (source of truth for the holiday picker)
        { label: <Icon.Eid size={20} fill="#73788B" />, value: 'eid' },
        { label: <Icon.BakriEid size={20} fill="#73788B" />, value: 'bakriEid' },
        { label: <Icon.Muharram size={20} fill="#73788B" />, value: 'muharram' },
        { label: <Icon.GoodFriday size={20} fill="#73788B" />, value: 'goodFriday' },
        { label: <Icon.Easter size={20} fill="#73788B" />, value: 'easter' },
        { label: <Icon.GuruNanakJayanti size={20} fill="#73788B" />, value: 'guruNanakJayanti' },
        { label: <Icon.MahavirJayanti size={20} fill="#73788B" />, value: 'mahavirJayanti' },
        { label: <Icon.BuddhaPurnima size={20} fill="#73788B" />, value: 'buddhaPurnima' },
        { label: <Icon.MahaShivratri size={20} fill="#73788B" />, value: 'mahaShivratri' },
        { label: <Icon.RamNavami size={20} fill="#73788B" />, value: 'ramNavami' },
        { label: <Icon.ChhathPuja size={20} fill="#73788B" />, value: 'chhathPuja' },
        { label: <Icon.Pongal size={20} fill="#73788B" />, value: 'pongal' },
        { label: <Icon.Onam size={20} fill="#73788B" />, value: 'onam' },
        { label: <Icon.Baisakhi size={20} fill="#73788B" />, value: 'baisakhi' },
        { label: <Icon.Ugadi size={20} fill="#73788B" />, value: 'ugadi' },
        { label: <Icon.Bihu size={20} fill="#73788B" />, value: 'bihu' },
        { label: <Icon.GandhiJayanti size={20} fill="#73788B" />, value: 'gandhiJayanti' },
        { label: <Icon.LabourDay size={20} fill="#73788B" />, value: 'labourDay' },
        { label: <Icon.WomensDay size={20} fill="#73788B" />, value: 'womensDay' },
        { label: <Icon.NewYear size={20} fill="#73788B" />, value: 'newYear' },
        { label: <Icon.Summer size={20} fill="#73788B" />, value: 'summer' },
        { label: <Icon.Monsoon size={20} fill="#73788B" />, value: 'monsoon' },
        { label: <Icon.Winter size={20} fill="#73788B" />, value: 'winter' },
        { label: <Icon.FoundationDay size={20} fill="#73788B" />, value: 'foundationDay' },
        { label: <Icon.CompanyEvent size={20} fill="#73788B" />, value: 'companyEvent' },
        { label: <Icon.TeamOuting size={20} fill="#73788B" />, value: 'teamOuting' },
        { label: <Icon.Birthday size={20} fill="#73788B" />, value: 'birthday' },
        { label: <Icon.Gift size={20} fill="#73788B" />, value: 'gift' },
        { label: <Icon.Star size={20} fill="#73788B" />, value: 'star' },
        { label: <Icon.Calendar size={20} fill="#73788B" />, value: 'calendar' },
        { label: <Icon.RangPanchami size={20} fill="#73788B" />, value: 'rangPanchami' },
        { label: <Icon.GudiPadwa size={20} fill="#73788B" />, value: 'gudiPadwa' },
        { label: <Icon.MaharashtraDay size={20} fill="#73788B" />, value: 'maharashtraDay' },
        { label: <Icon.LaxmiPujan size={20} fill="#73788B" />, value: 'laxmiPujan' },
        { label: <Icon.GauriVisarjan size={20} fill="#73788B" />, value: 'gauriVisarjan' },
        { label: <Icon.AnantChaturdashi size={20} fill="#73788B" />, value: 'anantChaturdashi' },
        { label: <Icon.BaliPratipada size={20} fill="#73788B" />, value: 'baliPratipada' },
        { label: <Icon.Bhaubij size={20} fill="#73788B" />, value: 'bhaubij' },
        { label: <Icon.OptionalHoliday size={20} fill="#73788B" />, value: 'optionalHoliday' },
        { label: <Icon.Holiday size={20} fill="#73788B" />, value: 'default' },
    ],
    LEAVE_ICON: [
        { label: <Icon.Annual size={20} fill="#73788B" />, value: 'AnnualLeaveIcon' },
        { label: <Icon.Lwp size={20} fill="#73788B" />, value: 'PaidLeaveIcon' },
        { label: <Icon.Casual size={20} fill="#73788B" />, value: 'CasualLeaveIcon' },
        { label: <Icon.Sick size={20} fill="#73788B" />, value: 'SickLeaveIcon' },
        { label: <Icon.Lwp size={20} fill="#73788B" />, value: 'LwpIcon' },
        { label: <Icon.Maternity size={20} fill="#73788B" />, value: 'MaternityLeaveIcon' },
        { label: <Icon.Marriage size={20} fill="#73788B" />, value: 'MarriageleaveIcon' },
        { label: <Icon.Bereavement size={20} fill="#73788B" />, value: 'BereavementLeaveIcon' },
        { label: <Icon.Compensatory size={20} fill="#73788B" />, value: 'CompensatoryLeaveIcon' },
        { label: <Icon.Paternity size={20} fill="#73788B" />, value: 'PaternityLeaveIcon' },
    ],
    STATE: [
        { "label": "Andhra Pradesh", "value": "Andhra Pradesh" },
        { "label": "Arunachal Pradesh", "value": "Arunachal Pradesh" },
        { "label": "Assam", "value": "Assam" },
        { "label": "Bihar", "value": "Bihar" },
        { "label": "Chhattisgarh", "value": "Chhattisgarh" },
        { "label": "Goa", "value": "Goa" },
        { "label": "Gujarat", "value": "Gujarat" },
        { "label": "Haryana", "value": "Haryana" },
        { "label": "Himachal Pradesh", "value": "Himachal Pradesh" },
        { "label": "Jammu and Kashmir", "value": "Jammu and Kashmir" },
        { "label": "Jharkhand", "value": "Jharkhand" },
        { "label": "Karnataka", "value": "Karnataka" },
        { "label": "Kerala", "value": "Kerala" },
        { "label": "Madhya Pradesh", "value": "Madhya Pradesh" },
        { "label": "Maharashtra", "value": "Maharashtra" },
        { "label": "Manipur", "value": "Manipur" },
        { "label": "Meghalaya", "value": "Meghalaya" },
        { "label": "Mizoram", "value": "Mizoram" },
        { "label": "Nagaland", "value": "Nagaland" },
        { "label": "Odisha", "value": "Odisha" },
        { "label": "Punjab", "value": "Punjab" },
        { "label": "Rajasthan", "value": "Rajasthan" },
        { "label": "Sikkim", "value": "Sikkim" },
        { "label": "Tamil Nadu", "value": "Tamil Nadu" },
        { "label": "Telangana", "value": "Telangana" },
        { "label": "Tripura", "value": "Tripura" },
        { "label": "Uttarakhand", "value": "Uttarakhand" },
        { "label": "Uttar Pradesh", "value": "Uttar Pradesh" },
        { "label": "West Bengal", "value": "West Bengal" },
        { "label": "Andaman and Nicobar Islands", "value": "Andaman and Nicobar Islands" },
        { "label": "Chandigarh", "value": "Chandigarh" },
        { "label": "Dadra and Nagar Haveli", "value": "Dadra and Nagar Haveli" },
        { "label": "Daman and Diu", "value": "Daman and Diu" },
        { "label": "Delhi", "value": "Delhi" },
        { "label": "Lakshadweep", "value": "Lakshadweep" },
        { "label": "Puducherry", "value": "Puducherry" },
    ],
}

export const STR = {
    taskCreate: "Task created successfully!",
    taskDelete: "Task deleted successfully!",
    taskComplete: "Task completed successfully!",
    subTaskComplete: "All Sub Task completed successfully!",
    taskUnComplete: "Task in-completed successfully!",
    permission: "You don't have permission",
    taskPermission: "You don't have permission to view this task",
}

export const SUCCESS = {
    applyLeave: 'Leave applied successfully!',

    assignEmployee: 'Employee assigned successfully!',

    whatsappIntegrationConnected: 'WhatsApp Business number connected successfully!',
    whatsappIntegrationDisconnected: 'WhatsApp Business number disconnected successfully!',
    whatsappIntegrationSynced: 'Template status refreshed successfully!',
}

export const valid = {
    descriptions: "between:3,500,string",
    note: "max:500,string",
    reason: "between:3,500,string",
    comments: "between:3,500,string",
}

export const DESPOSABLE_EMAIL = [
    "0x01.gq",
    "0x01.tk",
    "10mail.org",
    "10mail.tk",
    "33m.co",
    "33mail.com",
    "3dxtras.com",
    "3utilities.com",
    "567map.xyz",
    "8191.at",
    "aa.am",
    "accountsite.me",
    "acmetoy.com",
    "acusupply.com",
    "adultvidlite.com",
    "aji.kr",
    "anonaddy.com",
    "anonaddy.me",
    "anonbox.net",
    "anyalias.com",
    "asanatest1.us",
    "azzawajalla.store",
    "bajetesik.store",
    "band-freier.de",
    "bandband1.com",
    "bangmadid.store",
    "batikbantul.com",
    "bccto.me",
    "bebekpenyet.buzz",
    "bei.kr",
    "bel.kr",
    "beo.kr",
    "bfo.kr",
    "bgsaddrmwn.me",
    "bho.kr",
    "biasaelho.space",
    "biz.st",
    "biz.tm",
    "bko.kr",
    "blacksong.pw",
    "blueauramassage.com",
    "bounceme.net",
    "bum.net",
    "buwosok.tech",
    "buzzndaraiangop2wae.buzz",
    "byui.me",
    "caboodle.buzz",
    "cad.edu.gr",
    "cempue.online",
    "chickenkiller.com",
    "choirul.host",
    "cid.kr",
    "ciran.xyz",
    "cko.kr",
    "cloudns.asia",
    "cloudns.cc",
    "cloudns.cx",
    "cloudns.nz",
    "com.com",
    "coms.hk",
    "comx.cf",
    "craigslist.org",
    "creo.site",
    "creo.tips",
    "creou.dev",
    "crowdpress.it",
    "cu.cc",
    "cua77.xyz",
    "d3vs.net",
    "dadosa.xyz",
    "danuarte.online",
    "darrels.site",
    "daseus.online",
    "dayatan.host",
    "dbo.kr",
    "ddns.net",
    "ddnsfree.com",
    "deail.com",
    "dedyn.io",
    "defaultdomain.ml",
    "discard-email.cf",
    "dko.kr",
    "dlink.cf",
    "dlink.gq",
    "dlyemail.com",
    "dmtc.dev",
    "dmtc.edu.pl",
    "dmtc.press",
    "dns-cloud.net",
    "dns.navy",
    "dnsabr.com",
    "dnses.ro",
    "doy.kr",
    "drope.ml",
    "dropmail.me",
    "dynu.net",
    "dzalaev-advokat.ru",
    "e4ward.com",
    "ediantenan.site",
    "edu.auction",
    "efo.kr",
    "eho.kr",
    "ely.kr",
    "email-temp.com",
    "emailfake.com",
    "emailfake.ml",
    "emailfreedom.ml",
    "emlhub.com",
    "emlpro.com",
    "emltmp.com",
    "emy.kr",
    "enu.kr",
    "eny.kr",
    "epizy.com",
    "escritossad.net",
    "ese.kr",
    "esy.es",
    "ewa.kr",
    "exi.kr",
    "ezyro.com",
    "fackme.gq",
    "fassagforpresident.ga",
    "firste.ml",
    "flu.cc",
    "foy.kr",
    "fr.nf",
    "freeml.net",
    "gadzooks.buzz",
    "gettrials.com",
    "giize.com",
    "gmail.gr.com",
    "gmeil.me",
    "gok.kr",
    "gotdns.ch",
    "gpa.lu",
    "grigio.cf",
    "guardmail.cf",
    "haddo.eu",
    "heliohost.org",
    "higogoya.com",
    "historial.store",
    "hitechinfo.com",
    "hix.kr",
    "hiz.kr",
    "hmail.us",
    "hopto.org",
    "hostingarif.me",
    "idn.vn",
    "iesco.info",
    "igg.biz",
    "ignorelist.com",
    "iki.kr",
    "ilovemyniggers.club",
    "imouto.pro",
    "info.tm",
    "infos.st",
    "irr.kr",
    "isgre.at",
    "it2-mail.tk",
    "jil.kr",
    "jindmail.club",
    "jto.kr",
    "junnuok.com",
    "justemail.ml",
    "kadokawa.top",
    "kantal.buzz",
    "keitin.site",
    "kentel.buzz",
    "kerl.cf",
    "kerl.gq",
    "kikwet.com",
    "kondomeus.site",
    "kozow.com",
    "kranjingan.store",
    "kranjingan.tech",
    "kranjingans.tech",
    "kro.kr",
    "lal.kr",
    "laste.ml",
    "lbe.kr",
    "legundi.site",
    "lei.kr",
    "likevip.net",
    "liopers.link",
    "lko.co.kr",
    "lko.kr",
    "ll47.net",
    "lofteone.ru",
    "lom.kr",
    "longdz.site",
    "longmusic.com",
    "lostandalone.com",
    "loudcannabisapp.com",
    "loy.kr",
    "loyalherceghalom.ml",
    "luk2.com",
    "luksarcenter.ru",
    "luo.kr",
    "lyrics-lagu.me",
    "mail-temp.com",
    "mail0.ga",
    "mailinator.com",
    "mailr.eu",
    "marrone.cf",
    "mbe.kr",
    "mblimbingan.space",
    "mebelnovation.ru",
    "mefound.com",
    "mintemail.com",
    "mishmash.buzz",
    "mko.kr",
    "mlo.kr",
    "mooo.com",
    "motifasidiri.website",
    "mp-j.cf",
    "mp-j.ga",
    "mp-j.gq",
    "mp-j.ml",
    "mp-j.tk",
    "mr-meshkat.com",
    "mrossi.cf",
    "mrossi.gq",
    "mrossi.ml",
    "ms1.email",
    "msdc.co",
    "muabanwin.net",
    "museumplanet.com",
    "my.id",
    "my3mail.cf",
    "my3mail.ga",
    "my3mail.gq",
    "my3mail.ml",
    "my3mail.tk",
    "myddns.me",
    "myeslbookclub.com",
    "mymy.cf",
    "mysafe.ml",
    "mzon.store",
    "n-e.kr",
    "nafko.cf",
    "nctu.me",
    "netmail.tk",
    "netricity.nl",
    "new-mgmt.ga",
    "ngalasmoen.xyz",
    "ngguwokulon.online",
    "njambon.space",
    "nko.kr",
    "now.im",
    "npv.kr",
    "nuo.co.kr",
    "nuo.kr",
    "nut.cc",
    "o-r.kr",
    "oazis.site",
    "obo.kr",
    "ocry.com",
    "office.gy",
    "okezone.bid",
    "one.pl",
    "onlysext.com",
    "oovy.org",
    "oppoesrt.online",
    "orangotango.ml",
    "otherinbox.com",
    "ourhobby.com",
    "owa.kr",
    "owh.ooo",
    "oyu.kr",
    "p-e.kr",
    "pafnuty.com",
    "pandies.space",
    "paqeh.online",
    "pe.hu",
    "petinggiean.tech",
    "peyekkolipi.buzz",
    "poderosamulher.com",
    "poistaa.com",
    "porco.cf",
    "poy.kr",
    "prapto.host",
    "probatelawarizona.com",
    "ptcu.dev",
    "pubgm.website",
    "qbi.kr",
    "qc.to",
    "r-e.kr",
    "ragel.me",
    "rao.kr",
    "reilis.site",
    "rf.gd",
    "ringen.host",
    "rko.kr",
    "rosso.ml",
    "row.kr",
    "rr.nu",
    "rshagor.xyz",
    "s-ly.me",
    "safe-mail.gq",
    "sagun.info",
    "samsueng.site",
    "saucent.online",
    "sborra.tk",
    "schwarzmail.ga",
    "seluang.com",
    "sempak.link",
    "sendaljepit.site",
    "sendangagung.online",
    "servegame.com",
    "shp7.cn",
    "siambretta.com",
    "skodaauto.cf",
    "soju.buzz",
    "solidplai.us",
    "somee.com",
    "spamtrap.ro",
    "spymail.one",
    "ssanphone.me",
    "standeight.com",
    "statuspage.ga",
    "steakbeef.site",
    "stonedogdigital.com",
    "stop-my-spam.pp.ua",
    "storeyee.com",
    "sumanan.site",
    "supere.ml",
    "svblog.com",
    "sytes.net",
    "tandy.co",
    "tangtingtung.tech",
    "teml.net",
    "tempembus.buzz",
    "tempremail.cf",
    "tempremail.tk",
    "tgwrzqr.top",
    "thepieter.com",
    "theworkpc.com",
    "thinktimessolve.info",
    "thumoi.com",
    "tko.co.kr",
    "tko.kr",
    "tmo.kr",
    "tmpeml.com",
    "toh.info",
    "toi.kr",
    "tomcrusenono.host",
    "topikurrohman.xyz",
    "tourbalitravel.com",
    "traveldesk.com",
    "tricakesi.store",
    "trillianpro.com",
    "twilightparadox.com",
    "tyrex.cf",
    "uha.kr",
    "uk.to",
    "uko.kr",
    "umy.kr",
    "unaux.com",
    "undo.it",
    "uny.kr",
    "uola.org",
    "upy.kr",
    "urbanban.com",
    "us.to",
    "usa.cc",
    "uu.gl",
    "uvy.kr",
    "uyu.kr",
    "vay.kr",
    "vba.kr",
    "veo.kr",
    "viola.gq",
    "vivoheroes.xyz",
    "vkbags.in",
    "vo.uk",
    "volvo-xc.tk",
    "vuforia.us",
    "wakultimbo.buzz",
    "web.id",
    "weprof.it",
    "werkuldino.buzz",
    "wil.kr",
    "wingkobabat.buzz",
    "x24hr.com",
    "xiaomie.store",
    "xo.uk",
    "xxi2.com",
    "yarien.eu",
    "yawahid.host",
    "ye.vc",
    "yertxenor.tk",
    "yomail.info",
    "yopmail.com",
    "yoqoyyum.space",
    "youdontcare.com",
    "zalvisual.us",
    "zapto.org",
    "ze.cx",
    "zeroe.ml"
]
export const CUSTOM_FIELD_TYPE = {
    TEXT: 1,
    TEXT_AREA: 2,
    EMAIL: 3,
    NUMBER: 4,
    DATE: 5,
    SELECT: 6,
    RADIO: 7,
    CHECKBOX: 8,
    FILE: 9,
    TOGGLE: 10,
    NUMBER_WITH_FILE: 11,
    TEXT_WITH_FILE: 12,
    MULTI_SELECT: 13,
    CONTACT: 14,
    SINGLE_USER_SELECT: 15,
    MULTI_USER_SELECT: 16,

    1: "TEXT",
    2: "TEXT_AREA",
    3: "EMAIL",
    4: "NUMBER",
    5: "DATE",
    6: "SELECT",
    7: "RADIO",
    8: "CHECKBOX",
    9: "FILE",
    10: "TOGGLE",
    11: "NUMBER_WITH_FILE",
    12: "TEXT_WITH_FILE",
    13: "MULTI_SELECT",
    14: "CONTACT",
    15: "SINGLE_USER_SELECT",
    16: "MULTI_USER_SELECT",

    ARRAY_LIST: [
        {
            value: 1,
            label: 'Single Line Text',
            icon: <Icon.HTMLEditor fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 2,
            label: 'Multi Line Text',
            icon: <Icon.Multiline fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 3,
            label: 'Email',
            icon: <Icon.Mail fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 4,
            label: 'Number',
            icon: <Icon.NumberList fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 5,
            label: 'Date',
            icon: <Icon.Calendar fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 6,
            label: 'Dropdown',
            icon: <Icon.ListData fill={COLOR.u_icon_bg} size={14} className="" />
        },
        // {
        //     value: 7,
        //     label: 'Yes/No',
        //     icon: <Icon.YesNo fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 8,
        //     label: 'Single Choice',
        //     icon: <Icon.CheckMark fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 9,
        //     label: 'Attachment',
        //     icon: <Icon.Attachment fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        {
            value: 10,
            label: 'Toggle',
            icon: <Icon.YesNo fill={COLOR.u_icon_bg} size={14} className="" />
        },
        // {
        //     value: 11,
        //     label: 'Number with Attachment',
        //     icon: <Icon.Attachment fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 12,
        //     label: 'Text with Attachment',
        //     icon: <Icon.Attachment fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        {
            value: 13,
            label: 'Multi Select',
            icon: <Icon.MultiSelect fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 14,
            label: 'Contact',
            icon: <Icon.Contact fill={COLOR.u_icon_bg} size={14} className="" />
        },

    ],
}

/**
 * Default field definitions per profile section.
 * Single source of truth for:
 *   - which defaultKeys belong to a section (frontend-owned fields)
 *   - fallback values when the backend config is missing
 *
 * Each entry exposes the common useful keys: name, defaultKey, isRequired, isActive, isAddEmployeeRequired.
 *
 * Consumed automatically by `useCustomFieldConfig(section)` — callers do NOT need to pass these.
 * Callers may still pass a custom list as the second arg to override the defaults for that call site.
 */
export const PROFILE_DEFAULT_FIELDS = {
    [PROFILE_SECTION.client]: [
        { defaultKey: 'icon', name: 'Upload Photo', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.FILE, sortOrder: 1 },
        { defaultKey: 'companyName', name: 'Company Name', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 2 },
        { defaultKey: 'firstName', name: 'Client First Name', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 3 },
        { defaultKey: 'lastName', name: 'Client Last Name', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 4 },
        { defaultKey: 'email', name: 'Work Email Address', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.EMAIL, sortOrder: 5 },
        { defaultKey: 'phoneNumber', name: 'Phone Number', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.CONTACT, sortOrder: 6 },
        { defaultKey: 'country', name: 'Country', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 7 },
        { defaultKey: 'state', name: 'State', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 8 },
        { defaultKey: 'city', name: 'City', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 9 },
        { defaultKey: 'zip', name: 'Zip', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT, sortOrder: 10 },
        { defaultKey: 'address', name: 'Address', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT_AREA, sortOrder: 11 },
        { defaultKey: 'additional_Info', name: 'Additional Information', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT_AREA, sortOrder: 12 },
        { defaultKey: 'files', name: 'Attachment', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.FILE, sortOrder: 13 },
    ],
    [PROFILE_SECTION.location]: [
        { defaultKey: 'name', name: 'Location name', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'head', name: 'Location Head', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SINGLE_USER_SELECT },
        { defaultKey: 'isHeadOffice', name: 'Head Office', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CHECKBOX },
        { defaultKey: 'address1', name: 'Address 1', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'address2', name: 'Address 2', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'country', name: 'Country', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'state', name: 'State', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'cluster', name: 'Cluster', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'city', name: 'City', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'zip', name: 'Pincode', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'zone', name: 'Zone', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'locationBillingType', name: 'Location Billing', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'industry', name: 'Industry', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'locationStartDate', name: 'Location Start Date', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'locationEndDate', name: 'Location Closing Date', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'subLocation', name: 'Sub Location', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.MULTI_SELECT },
        { defaultKey: 'businessUnit', name: 'Business Unit', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
    ],
    [PROFILE_SECTION.familyInfo]: [
        { defaultKey: 'familyRole', name: 'Relationship', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'name', name: 'Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'gender', name: 'Gender', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'dateOfDeath', name: 'Date of Death', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'dob', name: 'Date of Birth', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'occupation', name: 'Occupation', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'mobileNumber', name: 'Mobile Number', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CONTACT },
        { defaultKey: 'aadharNumber', name: 'Aadhaar Card (UID)', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'weddingAnniversaryDate', name: 'Wedding Date', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'dateOfDivorce', name: 'Date of Divorce', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'isHandicapped', name: 'Physical Handicap', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TOGGLE },
        { defaultKey: 'handicappedPercentage', name: 'Handicap Percentage', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'attachments', name: 'Attachment', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.FILE },
    ],
    [PROFILE_SECTION.basicInfo]: [
        { isAddEmpForm: true, defaultKey: 'companyId', name: 'Company', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { isAddEmpForm: true, defaultKey: 'legalEntityCompanyId', name: 'Legal Entity Company', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { isAddEmpForm: true, defaultKey: 'employeeId', name: 'Employee ID', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'uniqueId', name: 'Unique ID', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'firstName', name: 'First Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'middleName', name: 'Middle Name', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'lastName', name: 'Last Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'displayName', name: 'Display Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'dob', name: 'Date of Birth', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { isAddEmpForm: false, defaultKey: 'joiningDate', name: 'Joining Date', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.DATE },
        { isAddEmpForm: false, defaultKey: 'previousJoiningDate', name: 'Previous Joining Date', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { isAddEmpForm: true, defaultKey: 'gender', name: 'Gender', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { isAddEmpForm: true, defaultKey: 'maritalStatus', name: 'Marital Status', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { isAddEmpForm: true, defaultKey: 'bloodGroup', name: 'Blood Group', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { isAddEmpForm: true, defaultKey: 'ledgerCode', name: 'Ledger Code', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: false, defaultKey: 'bornPlace', name: 'Place of Birth', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'nationality', name: 'Nationality', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'isPhysicalHandicap', name: 'Physical Handicap', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TOGGLE },
        { isAddEmpForm: true, defaultKey: 'handicappedPercentage', name: 'Handicap Percentage', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.NUMBER },
        { isAddEmpForm: false, defaultKey: 'candidateId', name: 'Candidate ID', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
    ],
    [PROFILE_SECTION.contactSocial]: [
        { isAddEmpForm: true, defaultKey: 'email', name: 'Work Email', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.EMAIL },
        { isAddEmpForm: false, defaultKey: 'alternativeEmail', name: 'Personal Email', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.EMAIL },
        { isAddEmpForm: true, defaultKey: 'employeeCode', name: 'User Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'phoneNumber', name: 'Mobile Number', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CONTACT },
        { isAddEmpForm: true, defaultKey: 'password', name: 'Password', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: true, defaultKey: 'homePhone', name: 'Home Phone Number', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CONTACT },
        { isAddEmpForm: true, defaultKey: 'whatsAppNumber', name: 'WhatsApp Number', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CONTACT },
        { isAddEmpForm: false, defaultKey: 'linkedIn', name: 'LinkedIn', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: false, defaultKey: 'twitter', name: 'Twitter', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: false, defaultKey: 'skype', name: 'Skype', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { isAddEmpForm: false, defaultKey: 'instagram', name: 'Instagram', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
    ],
    [PROFILE_SECTION.emergencyContact]: [
        { defaultKey: 'name', name: 'Name', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'relation', name: 'Relationship', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'email', name: 'Email', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.EMAIL },
        { defaultKey: 'homeNumber', name: 'Home Number', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CONTACT },
        { defaultKey: 'phoneNumber', name: 'Mobile Number', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CONTACT },
        { defaultKey: 'address1', name: 'Address 1', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'address2', name: 'Address 2', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'city', name: 'City', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'country', name: 'Country', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'province', name: 'State / Province', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'zip', name: 'Pin Code', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
    ],
    [PROFILE_SECTION.address]: [
        { defaultKey: 'address1', name: 'Address 1', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'address2', name: 'Address 2', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'city', name: 'City', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'country', name: 'Country', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'province', name: 'State / Province', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'zip', name: 'Post Code', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
    ],
    [PROFILE_SECTION.education]: [
        { defaultKey: 'degreeType', name: 'Degree Type', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'university', name: 'University', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'specialization', name: 'Specialization', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'start', name: 'Start Month/Year', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'end', name: 'End Month/Year', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'attachments', name: 'Attachment', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.FILE },
    ],
    [PROFILE_SECTION.previousEmployee]: [
        { defaultKey: 'workExperience', name: 'Total Experience', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'totalExperienceYY', name: 'Total Years', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'totalExperienceMM', name: 'Total Months', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'companyName', name: 'Company Name', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'department', name: 'Department', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'jobTitle', name: 'Job Title', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'start', name: 'Start Month/Year', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'end', name: 'End Month/Year', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'attachments', name: 'Attachment', isRequired: false, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.FILE },
    ],
    [PROFILE_SECTION.jobInfo]: [
        { defaultKey: 'effectiveDate', name: 'Joining Date (Effective Date)', isRequired: true, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'location', name: 'Location', isRequired: true, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'subLocation', name: 'Sub Location', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'jobTitle', name: 'Job Title', isRequired: true, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'category', name: 'Category', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'department', name: 'Department', isRequired: true, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'subDepartment', name: 'Sub Department', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'reportTo', name: 'Reporting Manager', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SINGLE_USER_SELECT },
        { defaultKey: 'lineManager', name: 'Line Manager', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SINGLE_USER_SELECT },
        { defaultKey: 'lineManager2', name: 'Line Manager2', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.SINGLE_USER_SELECT },
        { defaultKey: 'employeeStatus', name: 'Employment Status', isRequired: true, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'endProbation', name: 'End Date', isRequired: false, isActive: true, isAddEmpForm: false, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'period', name: 'Period', isRequired: false, isActive: true, isAddEmpForm: false, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'notifyPeriod', name: 'Feedback Reminder (In Days)', isRequired: false, isActive: false, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'comments', name: 'Note', isRequired: false, isActive: true, isAddEmpForm: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT_AREA },
    ],
    [PROFILE_SECTION.bankInfo]: [
        { defaultKey: 'countryType', name: 'Country', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'accHolderName', name: 'Account Holder Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'bankId', name: 'Bank Name', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'branch', name: 'Branch', isRequired: false, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'accountNo', name: 'Account Number', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'ifsc', name: 'IFSC Code', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'accountType', name: 'Account Type', isRequired: true, isActive: true, isAddEmployeeRequired: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'iban', name: 'IBAN', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'swiftCode', name: 'SWIFT Code', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'bankCode', name: 'Bank Code', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'branchCode', name: 'Branch Code', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'routingNo', name: 'Routing Number', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'isActive', name: 'Primary Account', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.CHECKBOX },
        { defaultKey: 'attachments', name: 'Attachment', isRequired: true, isActive: true, isAddEmployeeRequired: false, type: CUSTOM_FIELD_TYPE.FILE },
    ],
    [PROFILE_SECTION.otherDocument]: [
        { defaultKey: 'name', name: 'Document Name', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'startDate', name: 'Start Date', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'endDate', name: 'End Date', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'expiryNotifyPeriod', name: 'Notify Period (In Days)', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.NUMBER },
        { defaultKey: 'files', name: 'Attachment', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.FILE },
    ],
    [PROFILE_SECTION.personalIdentifications]: [
        { defaultKey: 'proofType', name: 'Document Type', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'value', name: 'Document Number', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'name', name: 'Name As Per Document', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.TEXT },
        { defaultKey: 'expiredDate', name: 'Expiry Date', isRequired: false, isActive: true, type: CUSTOM_FIELD_TYPE.DATE },
        { defaultKey: 'attachments', name: 'Attachment', isRequired: true, isActive: true, type: CUSTOM_FIELD_TYPE.FILE },
    ],
    [PROFILE_SECTION.compensationInfo]:[
        { defaultKey: 'start', name: 'Start Date', isRequired: true, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'end', name: 'End Date', isRequired: true, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'period', name: 'Period(In Months)', isRequired: false, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'prevSalary', name: 'Previous Salary', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'incrementPer', name: 'Increment (%)', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'newSalary', name: 'New Salary', isRequired: true, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'frequency', name: 'Pay Frequency', isRequired: true, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'noticePeriod', name: 'Notice Period (In Days)', isRequired: false, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'notifyPeriod', name: 'Notify Period (In Days)', isRequired: false, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'salaryMode', name: 'Salary Mode', isRequired: true, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'description', name: 'Note', isRequired: false, isAddEmpForm: true, isActive: true, isAddEmployeeRequired: false },
    ],
    [PROFILE_SECTION.employeeResignation]:[
        { defaultKey: 'reason', name: 'Reason', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'start', name: 'Resignation Date', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'end', name: 'Last Working Day', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'rehire', name: 'Eligible to Rehire', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'note', name: 'Note', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
    ],
    [PROFILE_SECTION.agreementInfo]: [
        { defaultKey: 'start', name: 'Start Date', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'end', name: 'End Date', isRequired: true, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'period', name: 'Period(In Months)', isRequired: false, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'notifyPeriod', name: 'Notify Period (In Days)', isRequired: false, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
        { defaultKey: 'comments', name: 'Note', isRequired: false, isAddEmpForm: false, isActive: true, isAddEmployeeRequired: false },
    ],
    [PROFILE_SECTION.orgStructureInfo]: [
        { defaultKey: 'businessUnit', name: 'Business Unit', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT },
        { defaultKey: 'costCenter', name: 'Cost Center', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'grade', name: 'Grade', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'bands', name: 'Bands', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'segment', name: 'Segment', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'hub', name: 'Hub', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'territory', name: 'Territory', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'region', name: 'Region', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
        { defaultKey: 'workArea', name: 'Work Area', isRequired: false, isActive: true, isAddEmpForm: true, type: CUSTOM_FIELD_TYPE.SELECT},
    ]
}


/* ===== HRMS-specific constants relocated from hrms/src/common/constant.jsx (used by ./function/hrms.jsx) ===== */
export const ALLOCATION = {
    USER_ID: ["5f3e0cf283e9801a80bbca0e", "65cf576bce79b0bbd26e2618", "65e01145ee624871073361cd", "65d5b62232fca434884a219f", "65d5b7434e768ba62a16aaa7", "65d5b62332fca434884a225c", "65d5b62132fca434884a210a", "65d5b62432fca434884a22b8", "65d5b62232fca434884a21a1", "66e4063db34b3ad40c36c245"],
    LOCATION_TROUBLESHOOT : ['zNYAa9SchX', 'jLZvhEb123', 'Rn7KYG1Fnh', 'yr0QhYDkd5', 'XwySYhNV1N', "YzmEWqaBTO", "ULTr8amPw7"],
    CHAT_BOT: ["NLgyWdldGw", "E63OGGMoBU",  "bPofRIJ9xE", "eJge0TupOo", "zNYAa9SchX", "ZcFtZ8ToN9", 'xNMKXhUEbO', 'F4u87vQw4x'],
    PROFILE_REQUEST: ['EbNnixCoZL', 'NLgyWdldGw', 'Rn7KYG1Fnh', 'E63OGGMoBU', 'lAFrCdJqGQ', 'AUFUS6eZ1M', '8v9UkPe7dz', 'suVtYRxhQt', 'bqJ8PuZoKF', 'Izpc2GR7yQ'],
    WHATSAPP_NOTIFICATION:['ZbgbTg0qMu'],
    LOCATION_WISE_ATTENDANCE: ['CIe6kMPcaI', 'avaONEQCQY', 'F4u87vQw4x'],
    CUSTOM_SABBATICAL_LEAVE: ['lAFrCdJqGQ','Rn7KYG1Fnh'],
    CUSTOM_PUNCH_REPORT:['PveDkR7qXY','Rn7KYG1Fnh', 'mnxjxsl23P', "xNMKXhUEbO"],
    SLOT_SYSTEM_SETTING:['Bo3kAygtRd', 'o2n4mGJr6J', 'Rn7KYG1Fnh', "pxCn8AijmI", "avaONEQCQY", 'K69Tru3ikD'],
    IMPORT_LEAVE: ['lAFrCdJqGQ', 'Rn7KYG1Fnh'],
    DOWNLOAD_MONTHLY_STATUS_REPORT: ['E63OGGMoBU','J9aA1y64sn', 'K1LLqZPsY6', 'wPaFNzRjgL', 'NLgyWdldGw', 'jIsGF6fBB9', "xNMKXhUEbO", "U1RZ8HubbY"],
    MONTHLY_ATTENDANCE_SHEET:['lAFrCdJqGQ', 'E63OGGMoBU', 'Rn7KYG1Fnh', 'avaONEQCQY', 'jIsGF6fBB9', "xNMKXhUEbO"],
    ATTENDANCE_TARGET_REPORT : ['9qD2nowvjA' ,'Rn7KYG1Fnh'],
    MONTHLY_BILLING_SUMMARY_REPORT : ['jR8TqLjGRU' ,'Rn7KYG1Fnh','pxCn8AijmI'],
    ACTUAL_PRESENT_IN_LEAVE_POLICY: ["0BARxv96iK", "tCbt8ObenX", "xNMKXhUEbO", "Ey464vkN8L", "Rn7KYG1Fnh", "xNMKXhUEbO", 'oMwNk07St5'],
    PRESENT_DAY_IN_LEAVE_ENTITLEMENT: ["0BARxv96iK", "tCbt8ObenX", "xNMKXhUEbO", "Ey464vkN8L", "Rn7KYG1Fnh", "xNMKXhUEbO", 'oMwNk07St5'],
    ATTENDANCE_DASHBOARD: ["9qD2nowvjA"],
    YEARLY_SUMMARY_REPORT : ['pADCdbjufH', 'Rn7KYG1Fnh'],
    EMPLOYEE_WISE_LEAVE_REPORT : ['pADCdbjufH', 'Rn7KYG1Fnh'],
    WHATSAPP_NOTIFICATION_SETTINGS: ["2ZL8xMxGA5", "pxCn8AijmI", "E63OGGMoBU", "2ZL8xMxGA5"],
    NATIVE_APP_UPDATE: ["E63OGGMoBU" , "7wgMexid4t" , "HeeHF4EgNZ"],
    SELFIE_PDF_REPORT: ['Rn7KYG1Fnh'],
    COMPARE_PAYROLL_REPORT : ['EbNnixCoZL', 'Rn7KYG1Fnh'],
}

export const BANK_INFO_COUNTRY = [
    {value: 'INDIA', label: 'India ', type : 1},
    {value: 'UAE', label: 'United Arab Emirates',type : 2},
    {value: 'SINGAPORE', label: 'Singapore', type : 3},
    {value: 'EGYPT', label: 'Egypt', type : 4},
    {value: 'QATAR', label: 'Qatar', type : 5},
    {value: 'NIGERIA', label: 'Nigeria', type : 6},
    {value: 'KSA', label: 'Kingdom of Saudi Arabia', type : 7},
    {value: 'MALDIVES', label: 'Maldives', type : 8},
    {value: 'UNITED_STATES', label: 'United States', type : 9},
]

export const STATUS_OPTIONS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'Cancelled', status: 'cancelled', color: '#1E2538', value: 4},
];

export const BIO_ACTION = {
    1: {label: 'Added', color: 'u_color-green', bg: 'u_bg-lightgreen'},
    2: {label: 'Removed', color: 'u_color-red', bg: 'u_bg-lightred'},
    3: {label: 'Updated', color: 'u_color-blue', bg: 'u_bg-lightblue'},
}

export const D_FIELDS = {
    /*========================> Section 1 start - Personal <================================== */
    //------------- Sub section 1- basic info ----------------------
    companyId_basic: "companyId_4987b3",
    legalEntityCompanyId_basic: "legalEntityCompanyId_1d2ae8",
    employeeId_basic: "employeeId_d600be",
    uniqueId_basic: "uniqueId_22ae14",
    firstName_basic: "firstName_ef6d24",
    middleName_basic: "middleName_85f962",
    lastName_basic: "lastName_16a1f6",
    dob_basic: "dob_e065c5",
    joiningDate_basic: "joiningDate_b0260f",
    previousJoiningDate_basic: "previousJoiningDate_fy77bd",
    gender_basic: "gender_c395f5",
    maritalStatus_basic: "maritalStatus_8a30c8",
    bloodGroup_basic: "bloodGroup_91e9d9",
    ledgerCode_basic: "ledgerCode_feb98a",
    isPhysicalHandicap_basic: "isPhysicalHandicap_c183bf",
    displayName_basic: "displayName_8d8fcd",
    bornPlace_basic: "bornPlace_fc769d",
    nationality_basic: "nationality_fe0450",
    candidateId_basic : "candidateId_d600bg",
    handicappedPercentage_basic: "handicappedPercentage_ke1705",

    //------------- Sub section 2-  childsubsection - 1 Family info ----------------------
    name_family: "name_4e13a5",
    gender_family: "gender_05ae86",
    dob_family: "dob_3b59b9",
    occupation_family: "occupation_23bba4",
    mobileNumber_family: "mobileNumber_cd69c5",
    aadharNumber_family: "aadharNumber_2cf1ff",
    isHandicapped_family: "isHandicapped_f0ab01",
    handicappedPercentage_family: "handicappedPercentage_kej005",
    attachments_family: "attachments_8606ec",
    dateOfDeath_family: "dateOfDeath_4d22a5",
    weddingAnniversaryDate_family: "weddingAnniversaryDate_24fa44",
    dateOfDivorce_family: "dateOfDivorce_f0ab01",
    relationship_family: "relationship_dhi83b",

    //------------- Sub section 2-  childsubsection - 2- Nominee info ----------------------
    nomineeName_nominee: "nomineeName_24fa44",
    nomineeRelation_nominee: "nomineeRelation_623442",
    nomineeFor_nominee: "nomineeFor_a029fa",
    percentageShare_nominee: "percentageShare_4d22a5",
    isMinor_nominee: "isMinor_f0ab01",
    note_nominee: "note_8606ec",

    //------------- Sub section 2-  childsubsection - 3- Dependent info ----------------------
    dependentName_dependent: "dependentName_0e93c0",
    dependentRelation_dependent: "dependentRelation_b6b3bd",

    //------------- Sub section 3-   childsubsection - 1 Contacts-----------------------
    email_contact: "email_cd8a28",
    alternativeEmail_contact: "alternativeEmail_7cc716",
    employeeCode_contact: "employeeCode_ad5cd1",
    phoneNumber_contact: "phoneNumber_d75060",
    homePhone_contact: "homePhone_26ca0f",
    whatsAppNumber_contact: "whatsAppNumber_f8f3e4",
    password_contact: "password_4375a7",
    aftrp_contact: "aftrp_d75061",

    //------------- Sub section 3-   childsubsection - 2 Socials-----------------------
    linkedIn_social: "linkedIn_4375a7",
    twitter_social: "twitter_005a11",
    skype_social: "skype_b088da",
    instagram_social: "instagram_3d0f47",

    // //------------- Sub section 4- bank info ----------------------
    // countryType_bank: "countryType_cbec2b",
    // accHolderName_bank: "accHolderName_dac717",
    // bankId_bank: "bankId_5259cc",
    // branch_bank: "branch_922077",
    // accountNo_bank: "accountNo_394ca5",
    // iban_bank: "iban_b6af64",
    // ifsc_bank: "ifsc_7536bc",
    // swiftCode_bank: "swiftCode_104862",
    // attachments_bank: "attachments_e95ea5",
    // accountType_bank: "accountType_e97f12",

    //------------- Sub section 5- Address ----------------------
    address1_address: "address1_67fe7f",
    address2_address: "address2_9972d1",
    city_address: "city_9d4a2a",
    country_address: "country_f644fc",
    province_address: "province_357158",
    zip_address: "zip_177fd9",

    //------------- Sub section 6- Education ----------------------
    degreeType_education: "degreeType_dde6d9",
    university_education: "university_08fa28",
    specialization_education: "specialization_d45754",
    start_education: "start_e83ce5",
    end_education: "end_e11d57",
    attachments_education: "attachments_9g07eb",

    //------------- Sub section 7- Previous Employer ----------------------
    workExperience_employer: "workExperience_62004c",
    totalExperienceMM_employer: "totalExperienceMM_5e9907",
    totalExperienceYY_employer: "totalExperienceYY_a4d034",
    companyName_employer: "companyName_06a293",
    department_employer: "department_856cba",
    jobTitle_employer: "jobTitle_4b01bb",
    start_employer: "start_26208c",
    end_employer: "end_0d497e",
    attachments_employer: "attachments_k3j9xq",

    //------------- Sub section 8- Bank Info ----------------------
    countryType_bank: "countryType_cbec2b",
    accountType_bank: 'accountType_e97f12',
    attachments_bank: 'attachments_e95ea5',
    ifsc_bank: 'ifsc_7536bc',
    branchCode_bank: 'branchCode_f3a7c1',
    bankCode_bank: 'bankCode_b6d8e2',
    accountNo_bank: 'accountNo_394ca5',
    branch_bank: 'branch_922077',
    bankId_bank: 'bankId_5259cc',
    accHolderName_bank: 'accHolderName_dac717',
    swiftCode_bank: 'swiftCode_104862',
    iban_bank: 'iban_b6af64',

    /*===================================> Section 1 End - Personal <============================================ */


    // /*===================================> Section 2 Start - Job <============================================ */
    // //------------- Sub section 1- Job Info  ----------------------
    // joiningDate_b0260f: "joiningDate_b0260f",
    // location_c69114: "location_c69114",
    // jobTitle_b64839: "jobTitle_b64839",
    // department_ea077e: "department_ea077e",
    // employeeStatus_a12609: "employeeStatus_a12609",
    // subLocation_862370: "subLocation_862370",
    // category_dbe92f: "category_dbe92f",
    // subDepartment_baa778: "subDepartment_baa778",
    // reportTo_6366a0: "reportTo_6366a0",
    // lineManager_0042f4: "lineManager_0042f4",
    // comments_7fca27: "comments_7fca27",


    //------------- Sub section 2- Agreement  ----------------------
    start_agreement: "start_a26568",
    end_agreement: "end_29d3fd",
    period_agreement: "period_51485e",
    notifyPeriod_agreement: "notifyPeriod_503d6f",
    comments_agreement: "comments_949a87",


    //------------- Sub section 3- Compensation  ----------------------
    start_compensation: "start_2bd053",
    end_compensation: "end_cda740",
    period_compensation: "period_b5a4d6",
    incrementPer_compensation: "incrementPer_gt607y",
    prevSalary_compensation: "prevSalary_d5i7c0",
    newSalary_compensation: "newSalary_dee7c9",
    frequency_compensation: "frequency_fb47ea",
    noticePeriod_compensation: "noticePeriod_109b51",
    notifyPeriod_compensation: "notifyPeriod_8a1d73",
    salaryMode_compensation: "salaryMode_130a43",
    description_compensation: "description_6fa310",
    // compensationNewSalaryIsLeaveBonusBenefit_7cbbb6: "compensationNewSalaryIsLeaveBonusBenefit_7cbbb6",
    // compensationApplyBonus_4455ed: "compensationApplyBonus_4455ed",


    //------------- Sub section 4- Employee Resignation   ----------------------
    reason_resignation: "reason_0125b2",
    start_resignation: "start_5e5083",
    end_resignation: "end_0ba015",
    rehire_resignation: "rehire_5c1e96",
    note_resignation: "note_4ae92e",
    // type_ee8d84: "type_ee8d84",


    // //------------- Sub section 5- Internship/probation ----------------------
    // start_e1a203: "start_e1a203",
    // end_a453d0: "end_a453d0",
    // length_68d91b: "length_68d91b",
    // // { section: 2, subSection: 5, type: 6, name: "Employment Status", fieldName: "Employment Status", isActive: true, isRequired: false, isAddEmpForm: false, sortOrder:4},
    // // { section: 2, subSection: 5, type: 6, name: "Reduce/Extended", fieldName: "Reduce/Extended", isActive: true, isRequired: false, isAddEmpForm: false, sortOrder:5},
    // //

    // //------------- Sub section 6- Org Structure ----------------------
    businessUnit_caa8aa: "businessUnit_caa8aa",
    costCenter_c8b6af: "costCenter_c8b6af",
    grade_7c65fc: "grade_7c65fc",
    bands_634c80: "bands_634c80",
    segment_1b01a1: "segment_1b01a1",
    hub_c05020: "hub_c05020",
    territory_ca2b9d: "territory_ca2b9d",
    region_10c7f8: "region_10c7f8",
    workArea_895762: "workArea_895762",

    // /*===================================> Section 2 End - Job <=============================================*/


    // /*===================================> Section 3 Start - Documents <============================================ */
    //------------- Sub section 1- Personal Identifications ----------------------
    aadharNumber_04114c: "aadharNumber_04114c",
    panNumber_72113f: "panNumber_72113f",
    attachments_personalId: "attachments",
    expiredDate_personalId: "expiredDate",
    expiredDate_personal: 'expiredDate_4b7a9f',
    attachments_personal: 'attachments_8c3f2d',

    // /*===================================> Section 4 Start - Location <============================================ */
    //------------- Sub section 1- Location ----------------------
    name_location: "locationName_4f1a21",
    head_location: "locationHead_c82b4f",
    isHeadOffice_location: "headOffice_a3d9f2",
    address1_location: "locationAddress1_91b63a",
    address2_location: "locationAddress2_2d4c8e",
    country_location: "locationCountry_8e5f0d",
    state_location: "locationState_54a19c",
    cluster_location: "locationCluster_7db2e1",
    city_location: "locationCity_3ac7b9",
    zip_location: "locationPincode_6fd142",
    zone_location: "locationZone_18cb73",
    locationBillingType_location: "locationBilling_bf9415",
    industry_location: "locationIndustry_52ae84",
    locationStartDate_location: "locationStartDate_11de30",
    locationEndDate_location: "locationClosingDate_0a9f67",
    subLocation_location: "subLocation_e7c5b3",
    businessUnit_location:"locationBusinessUnit_b2f6a1",
    // /*===================================> Section 4 End - Location <============================================ */

    // /*===================================> Section 5 Start - Sub Company <============================================ */
    //------------- Sub section 1- Sub Company ----------------------
    company_subCompany: "subCompanyName_1a2b3c",
    domain_subCompany: "subCompanyIndustry_4d5e6f",
    registrationNumber_subCompany: "subCompanyRegNumber_7g8h9i",
    iec_subCompany: "subCompanyIEC_0j1k2l",
    pan_subCompany: "subCompanyPAN_3m4n5o",
    tan_subCompany: "subCompanyTAN_6p7q8r",
    startAt_subCompany: "subCompanyStartDate_9s0t1u",
    GSTNumber_subCompany: "subCompanyGST_2v3w4x",
    // /*===================================> Section 5 End - Sub Company <============================================ */

}

export const OPERATORS = {
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    INCLUDES: 'includes',
    NOT_INCLUDES: 'notIncludes',
    GREATER_THAN: 'gt',
    LESS_THAN: 'lt',
    GREATER_EQUAL: 'gte',
    LESS_EQUAL: 'lte',
    CONTAINS: 'contains',
    EMPTY: 'empty',
    NOT_EMPTY: 'notEmpty',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    IS_TRUTHY: 'isTruthy',         // ✅ New
    IS_NOT_TRUTHY: 'isNotTruthy', // ✅ New
};

export const BASIC_INFO_ACTIVITY_KEY = [
  "companyId",
  "legalEntityCompanyId",
  "employeeId",
  "uniqueId",
  "joiningDate",
  "previousJoiningDate",
  "firstName",
  "middleName",
  "lastName",
  "dob",
  "gender",
  "maritalStatus",
  "bloodGroup",
  "isPhysicalHandicap",
  "handicappedPercentage",
  "ledgerCode",
  "displayName",
  "bornPlace",
  "nationality",
  "candidateId"
]

/**
 * HRMS/Recruit Documents — letter-template watermark options.
 * Rendered only in the generated PDF (pdf-node buildWatermarkHtml); FONT_FAMILY is limited to
 * web-safe fonts because the watermark SVG background cannot load external font stylesheets.
 * VALUES holds the numeric codes stored in documentSettings.watermark — single source of
 * truth, mirrored by backend constant.HRMS.WATERMARK (utils/constant.js — keep both in sync).
 */
const WATERMARK_VALUES = {
    TYPE: {TEXT: 1, IMAGE: 2},
    LAYOUT: {SINGLE: 1, TILED: 2},
    THICKNESS: {LIGHT: 1, NORMAL: 2, BOLD: 3},
    ROTATION_DIRECTION: {ANTICLOCKWISE: 1, CLOCKWISE: 2},
    FONT_FAMILY: {ARIAL: 1, TIMES: 2, GEORGIA: 3, COURIER: 4},
    POSITION: {
        CENTER: 1,
        TOP_LEFT: 2, TOP_CENTER: 3, TOP_RIGHT: 4,
        MIDDLE_LEFT: 5, MIDDLE_RIGHT: 6,
        BOTTOM_LEFT: 7, BOTTOM_CENTER: 8, BOTTOM_RIGHT: 9,
    },
};

export const DOCUMENT_WATERMARK = {
    VALUES: WATERMARK_VALUES,
    TYPE: [
        {label: 'Text', value: WATERMARK_VALUES.TYPE.TEXT},
        {label: 'Image', value: WATERMARK_VALUES.TYPE.IMAGE},
    ],
    LAYOUT: [
        {label: 'Single centered', value: WATERMARK_VALUES.LAYOUT.SINGLE},
        {label: 'Repeated', value: WATERMARK_VALUES.LAYOUT.TILED},
    ],
    THICKNESS: [
        {label: 'Light', value: WATERMARK_VALUES.THICKNESS.LIGHT},
        {label: 'Normal', value: WATERMARK_VALUES.THICKNESS.NORMAL},
        {label: 'Bold', value: WATERMARK_VALUES.THICKNESS.BOLD},
    ],
    ROTATION_DIRECTION: [
        {label: 'Anticlockwise', value: WATERMARK_VALUES.ROTATION_DIRECTION.ANTICLOCKWISE},
        {label: 'Clockwise', value: WATERMARK_VALUES.ROTATION_DIRECTION.CLOCKWISE},
    ],
    FONT_FAMILY: [
        {label: 'Arial', value: WATERMARK_VALUES.FONT_FAMILY.ARIAL},
        {label: 'Times New Roman', value: WATERMARK_VALUES.FONT_FAMILY.TIMES},
        {label: 'Georgia', value: WATERMARK_VALUES.FONT_FAMILY.GEORGIA},
        {label: 'Courier New', value: WATERMARK_VALUES.FONT_FAMILY.COURIER},
    ],
    // Anchor for a single-layout image watermark (image-only; center = legacy behavior).
    POSITION: [
        {label: 'Center', value: WATERMARK_VALUES.POSITION.CENTER},
        {label: 'Top Left', value: WATERMARK_VALUES.POSITION.TOP_LEFT},
        {label: 'Top Center', value: WATERMARK_VALUES.POSITION.TOP_CENTER},
        {label: 'Top Right', value: WATERMARK_VALUES.POSITION.TOP_RIGHT},
        {label: 'Middle Left', value: WATERMARK_VALUES.POSITION.MIDDLE_LEFT},
        {label: 'Middle Right', value: WATERMARK_VALUES.POSITION.MIDDLE_RIGHT},
        {label: 'Bottom Left', value: WATERMARK_VALUES.POSITION.BOTTOM_LEFT},
        {label: 'Bottom Center', value: WATERMARK_VALUES.POSITION.BOTTOM_CENTER},
        {label: 'Bottom Right', value: WATERMARK_VALUES.POSITION.BOTTOM_RIGHT},
    ],
    OPACITY: {MIN: 5, MAX: 40},
    SIZE: {MIN: 20, MAX: 200},
    ROTATION: {MIN: 0, MAX: 360},
    // Pixel nudge from the anchor (edge-relative; negatives crop off-edge).
    OFFSET: {MIN: -200, MAX: 200, STEP: 5},
    TEXT_MAX_LENGTH: 50,
    IMAGE_MAX_MB: 2,
    DEFAULT: {isActive: false, type: WATERMARK_VALUES.TYPE.TEXT, text: '', image: null, layout: WATERMARK_VALUES.LAYOUT.SINGLE, opacity: 10, size: 40, rotation: 0, rotationDirection: WATERMARK_VALUES.ROTATION_DIRECTION.ANTICLOCKWISE, color: '#808080', thickness: WATERMARK_VALUES.THICKNESS.NORMAL, fontFamily: WATERMARK_VALUES.FONT_FAMILY.ARIAL, position: WATERMARK_VALUES.POSITION.CENTER, offsetX: 0, offsetY: 0},
}

// Product ids as returned by the backend on a record (utils/constant.js PRODUCT_TYPE).
// Use for direct comparison, e.g. `row.productType === PRODUCT_TYPE.RECRUIT`.
export const PRODUCT_TYPE = {
    HRMS: 1,
    PAYROLL: 2,
    RECRUIT: 3,
    CHAT: 4,
    SURVEY: 5,
    PMS: 6,
    ASSETS: 7,
    TRACK: 8,
    PERFORMANCE: 9,
    LMS: 10,
};
/** Condition fields a requisition policy adds on top of the shared POLICY_AUTOMATION numbering. */
const REQUISITION_ONLY_FIELD = {JOB_TYPE: 18, PRIORITY: 19}

/**
 * Requisition approval-policy rule condition fields.
 *
 * A policy's `rules[].conditions[].field` is a numeric index. Indices 1-17 are the shared
 * POLICY_AUTOMATION numbering — reused as-is so the two can never drift — and requisitions add
 * two of their own. FIELD_LABEL is what the shared policy chooser
 * (UPolicyAutomation/requisition-policy-modal) prints for a condition.
 */
export const REQUISITION_POLICY = {
    FIELD: {...POLICY_AUTOMATION.CONDITION_FIELD, ...REQUISITION_ONLY_FIELD},
    FIELD_LABEL: {
        ...POLICY_AUTOMATION.CATEGORIES.reduce((acc, category) => ({...acc, [category.fieldIndex]: category.label}), {}),
        [REQUISITION_ONLY_FIELD.JOB_TYPE]: 'Job Type',
        [REQUISITION_ONLY_FIELD.PRIORITY]: 'Priority',
    },
}

// Mirrors backend utils/constant.js EMAIL_TEMPLATE_UTILS — moduleType stored on ats_email_template documents
export const EMAIL_TEMPLATE_UTILS = {
    RECRUIT_EMAIL_TEMPLATES: 1,
    HRMS_DOCUMENTS_EMAIL_TEMPLATE: 2,
    HRMS_ONBOARDING_EMAIL_TEMPLATE: 3,
}

export const CHECKIN_STATUS = [
    {label: 'Not Started', color: COLOR.u_icon_bg, value: 1},
    {label: 'On track', color: COLOR.u_green, value: 2},
    {label: 'At Risk', color: COLOR.u_orange, value: 3},
    {label: 'Off Track', color: COLOR.u_pastelred, value: 4},
    {label: 'Hold', color: COLOR.u_purple, value: 5},
    {label: 'Completed', color: COLOR.u_blue, value: 6}
]

export const EPF_SETTING = {
    WAGE_RESTRICT:[{amount:15000,date:new Date('2014-08-31T18:30:00.000+00:00')}],
    EPF_EMPLOYEE_RATE: [12],
    EPF_EMPLOYER_RATE: [13],
    EPF_EMPLOYER_SENIOR_CITIZEN_RATE: [6.5]
}

// TEMPORARY rollout: direct-to-S3 upload only for these orgs (NLgyWdldGw production, Vsy8sXgGFl and
// uTrn1V6bAZ staging). Every other org keeps the old server upload.
export const DIRECT_UPLOAD_ORG_IDS = ['NLgyWdldGw', 'Vsy8sXgGFl', 'uTrn1V6bAZ'];
// login-restriction rejections the apps show on the Access Restricted page
export const LOGIN_RESTRICTION_TYPES = ['Login Restriction', 'Account Blocked', 'uniqueId Conflict', 'uniqueId Required', 'Device Registered'];

export const ADDITIONAL_RESPONSIBILITY = {
    FREQUENCY: {MONTHLY: 1, QUARTERLY: 2, HALF_YEARLY: 3, YEARLY: 4, CUSTOM: 5},
    FREQUENCY_OPTIONS: [
        {label: 'Monthly', value: 1},
        {label: 'Quarterly', value: 2},
        {label: 'Half Yearly', value: 3},
        {label: 'Yearly', value: 4},
        {label: 'Custom', value: 5},
    ],
    FREQUENCY_MONTH_COUNT: {1: 12, 2: 4, 3: 2, 4: 1},
}
